
let locale: { [key: string]: string } = {};
let isMobileApplicationType: boolean = false;
let isNativeMobileApplicationType: boolean = false;
let isTabletApplicationType: boolean = false;
let accessibilityRoleOptions: Array<any> = ['none', 'adjustable', 'alert', 'button', 'checkbox', 'combobox', 'grid', 'header', 'image', 'imagebutton', 'link', 'menu', 'progressbar', 'radio', 'radiogroup', 'search', 'summary','tab', 'text', 'togglebutton'];

let showInDeviceOptions: Array<{ name: string; value: string }> | undefined = undefined;
let showInDeviceOptionsForMobile: Array<{ name: string; value: string }> | undefined = undefined;

let widgetEventOptions: Array<string> = [];

export function setShowInDeviceOptions() {
  showInDeviceOptionsForMobile = [{
    name: locale['LABEL_ALL'],
    value: 'all'
  }, {
    name: locale['LABEL_PROPERTY_MOBILE'],
    value: 'xs'
  }, {
    name: locale['LABEL_TABLET_PORTRAIT'],
    value: 'sm'
  }, {
    name: locale[isMobileApplicationType ? 'LABEL_TABLET_LANDSCAPE' : 'LABEL_LAPTOP_TABLET_LANDSCAPE'],
    value: 'md'
  }];
  showInDeviceOptions = showInDeviceOptionsForMobile.concat([{
    name: locale['LABEL_LARGE_SCREEN'],
    value: 'lg'
  }]);
  return isMobileApplicationType ? showInDeviceOptionsForMobile : showInDeviceOptions;
}

export function getShowInDeviceOptions() {
  return showInDeviceOptions;
}

export function getShowInDeviceOptionsForMobile() {
  return showInDeviceOptionsForMobile;
}

export function getWidgetEventOptions(){
   return widgetEventOptions;
}

export function setWidgetEvenOptions(options: Array<string>){
  widgetEventOptions = options;
}

export function setIsMobileApplicationType(isMobile: boolean){
  isMobileApplicationType = isMobile;
}
export function getIsMobileApplicationType(): boolean{
  return isMobileApplicationType;
}

export function setIsNativeMobileApplicationType(isNativeMobile: boolean){
  isNativeMobileApplicationType = isNativeMobile;
}
export function getIsNativeMobileApplicationType(): boolean{
  return isNativeMobileApplicationType;
}

export function setIsTabletApplicationType(isTablet: boolean){
  isTabletApplicationType = isTablet;
}
export function getIsTabletApplicationType(): boolean{
  return isTabletApplicationType;
}

export function setLocale(inLocale: { [key: string]: string }){
  locale = inLocale;
}
export function getLocale(): { [key: string]: string }{
  return locale;
}

export function setRoles(pRoles: Array<any>){
  roles = [];
  pRoles.forEach((pRole:any)=>{
    roles.push(pRole);
  });
}
export function getRoles(): Array<any>{
  return roles;
}

const columnWidths = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
const dayOptions = [{
    'name': 'Sunday',
    'value': '0'
  }, {
    'name': 'Monday',
    'value': '1'
  }, {
    'name': 'Tuesday',
    'value': '2'
  }, {
    'name': 'Wednesday',
    'value': '3'
  }, {
    'name': 'Thursday',
    'value': '4'
  }, {
    'name': 'Friday',
    'value': '5'
  }, {
    'name': 'Saturday',
    'value': '6'
  }];
const nameRegex = '^[a-zA-Z_][A-Za-z0-9_]+$';
const numberRegex = '(^$|[0-9]+$)';
const classRegex = '(^$|^-?[_a-zA-Z ]+[_a-zA-Z0-9- ]*)$';
const dimensionRegex = '(^$|^(auto|0)$|^[+-]?[0-9]+.?([0-9]+)?(em|ex|%|px|cm|mm|in|pt|pc|ch|rem|vh|vw|vmin|vmax)?$)';
const zindexRegex = '(^$|auto|initial|inherit|^[0-9]+$)';
const maxRatingRegex = '^(?:10|[1-9])$|^bind.*$';
let roles: Array<any> = [];
const matchModes = [{
    'labelkey': "LABEL_STARTS_WITH_IGNORE_CASE",
    'value': 'startignorecase'
  },
  {
    'labelkey': "LABEL_STARTS_WITH",
    'value': 'start'
  },
  {
    'labelkey': "LABEL_ENDS_WITH_IGNORE_CASE",
    'value': 'endignorecase'
  },
  {
    'labelkey': "LABEL_ENDS_WITH",
    'value': 'end'
  },
  {
    'labelkey': "LABEL_CONTAINS_IGNORE_CASE",
    'value': 'anywhereignorecase'
  },
  {
    'labelkey': "LABEL_CONTAINS",
    'value': 'anywhere'
  },
  {
    'labelkey': "LABEL_IS_EQUAL_WITH_IGNORE_CASE",
    'value': 'exactignorecase'
  },
  {
    'labelkey': "LABEL_IS_EQUAL",
    'value': 'exact'
  }];
const numberFormatOptions = [
    {
      "namekey": "LABEL_DECIMAL_DIGITS",
      "name": "Decimal Digits",
      "groupOptions": {
        ".0f": "9",
        ".1f": "9.9",
        ".2f": "9.99",
        ".3f": "9.999"
      }
    },
    {
      "namekey": "LABEL_PRECISION",
      "name": "Precision",
      "groupOptions": {
        ".1g": "9e+7",
        ".2g": "9.9e+7",
        ".3g": "9.99e+7"
      }
    },
    {
      "namekey": "LABEL_PERCENTAGE",
      "name": "Percentage",
      "groupOptions": {
        "%": "99%"
      }
    },
    {
      "namekey": "LABEL_ROUND_OPTIONS",
      "name": "Round Options",
      "groupOptions": {
        ",r": "99,999,999",
        "Thousand": "Thousand (Eg: 9K)",
        "Million": "Million (Eg: 9M)",
        "Billion": "Billion (Eg: 9B)"
      }
    }
  ];
const dateOptions = [
    {
      "name": "Date",
      "groupOptions": {
        "%x": "mm/dd/yyyy",
        "%c": "Date and Time"
      }
    },
    {
      "name": "Time",
      "groupOptions": {
        "%X": "Time(%H:%M:%S)",
        "%H": "In 24 hours [00-23]",
        "%I": "In 12 hours [01-12]",
        "%M": "Minutes [00-59]",
        "%S": "Seconds [00-59]",
        "%L": "MilliSeconds [000, 999]",
        "%p": "either AM or PM",
        "%Z": "Time zone offset"
      }
    },
    {
      "name": "Day",
      "groupOptions": {
        "%d": "Zero padded day of month (Eg: 01)",
        "%e": "Space padded day of month (Eg:  1)",
        "%j": "Day of the year (Eg: 01-31-2016 returns 031)"
      }
    },
    {
      "name": "Week",
      "groupOptions": {
        "%a": "Abbreviated weekday name (Eg: Wed)",
        "%A": "Full weekday name (Eg: Wednesday)",
        "%U": "Week number of the year(Sunday first day) (Eg: 01-31-2016 returns 05)",
        "%W": "Week number of the year(Monday first day) (Eg: 01-31-2016 returns 04)",
        "%w": "Week day[0(Sunday),6]  (Eg: 01-30-2016 returns 6)"
      }
    },
    {
      "name": "Month",
      "groupOptions": {
        "%b": "Abbreviated month name (Eg: Mar)",
        "%B": "Full month name  (Eg: March)",
        "%m": "Month number  (Eg: 02) [01-12]"
      }
    },
    {
      "name": "Year",
      "groupOptions": {
        "%y": "yy (Eg: 16)",
        "%Y": "yyyy (Eg: 2016)"
      }
    }
  ];
const timeGroupOptions = [{ "name": "TIME", "groupOptions": { "hour": "hour", "day": "day", "week": "week", "month": "month", "year": "year" } }];
const timeNonGroupOptions = [{ "labelkey": "LABEL_ALPHABET", "value": "alphabet" }, { "labelkey": "LABEL_WORD", "value": "word" }];
const PLATFORM_TYPE = {
    WEB: 'WEB',
    MOBILE: 'MOBILE',
    DEFAULT: 'DEFAULT'
  };
const dateTimeTypes = "timestamp, date, time, datetime, string, number";
const reactNativeAnimationOptions = [" ", "bounce", "bounceIn", "bounceInDown", "bounceInLeft", "bounceInRight", "bounceInUp", "bounceOut", "bounceOutDown", "bounceOutLeft", "bounceOutRight", "bounceOutUp", "fadeIn", "fadeInDown", "fadeInDownBig", "fadeInLeft", "fadeInLeftBig", "fadeInRight", "fadeInRightBig", "fadeInUp", "fadeInUpBig", "fadeOut", "fadeOutDown", "fadeOutDownBig", "fadeOutLeft", "fadeOutLeftBig", "fadeOutRight", "fadeOutRightBig", "fadeOutUp", "fadeOutUpBig", "flash", "flipInX", "flipInY", "flipOutX", "flipOutY", "lightSpeedIn", "lightSpeedOut", "pulse", "rotate", "rubberBand", "shake", "slideInDown", "slideInLeft", "slideInRight", "slideInUp", "slideOutDown", "slideOutLeft", "slideOutRight", "slideOutUp", "swing", "tada", "wobble", "zoomIn", "zoomInDown", "zoomInLeft", "zoomInRight", "zoomInUp", "zoomOut", "zoomOutDown", "zoomOutLeft", "zoomOutRight", "zoomOutUp"];
const animationOptions = [" ", "bounce", "bounceIn", "bounceInDown", "bounceInLeft", "bounceInRight", "bounceInUp", "bounceOut", "bounceOutDown", "bounceOutLeft", "bounceOutRight", "bounceOutUp", "fadeIn", "fadeInDown", "fadeInDownBig", "fadeInLeft", "fadeInLeftBig", "fadeInRight", "fadeInRightBig", "fadeInUp", "fadeInUpBig", "fadeOut", "fadeOutDown", "fadeOutDownBig", "fadeOutLeft", "fadeOutLeftBig", "fadeOutRight", "fadeOutRightBig", "fadeOutUp", "fadeOutUpBig", "flash", "flipInX", "flipInY", "flipOutX", "flipOutY", "hinge", "lightSpeedIn", "lightSpeedOut", "pulse", "rollIn", "rollOut", "rotateIn", "rotateInDownLeft", "rotateInDownRight", "rotateInUpLeft", "rotateInUpRight", "rotateOut", "rotateOutDownLeft", "rotateOutDownRight", "rotateOutUpLeft", "rotateOutUpRight", "rubberBand", "shake", "slideInDown", "slideInLeft", "slideInRight", "slideInUp", "slideOutDown", "slideOutLeft", "slideOutRight", "slideOutUp", "swing", "tada", "wobble", "zoomIn", "zoomInDown", "zoomInLeft", "zoomInRight", "zoomInUp", "zoomOut", "zoomOutDown", "zoomOutLeft", "zoomOutRight", "zoomOutUp"];
const spinnerAnimationOptions = [" ", "bounce", "fadeIn", "fadeOut", "flash", "flipInX", "flipInY", "pulse", "shake", "spin", "swing", "tada", "wobble", "zoomIn", "zoomOut"];
const textAnimationOptions = [" ", "fadeIn"];
const visibilityOptions = ["collapse", "hidden", "initial", "inherit", "visible"];
const displayOptions = ["block", "flex", "inherit", "initial", "inline", "inline-block", "inline-flex", "inline-table", "list-item", "run-in", "table", "table-caption", "table-cell", "table-column", "table-column-group", "table-header-group", "table-footer-group", "table-row", "table-row-group", "none"];
const popoverOptions = [
    {
      'value': 'top',
      'label': 'Top'
    },
    {
      'value': 'bottom',
      'label': 'Bottom'
    },
    {
      'value': 'left',
      'label': 'Left'
    },
    {
      'value': 'right',
      'label': 'Right'
    }
  ];

  const EVERYONE = "Everyone";
  const barcodeFormatOptions = [
    { "label": "ALL", "value": "ALL" },
    { "label": "CODABAR (not supported in iOS)", "value": "CODABAR" },
    { "label": "CODE_39", "value": "CODE_39" },
    { "label": "CODE_93 (not supported in iOS)", "value": "CODE_93" },
    { "label": "CODE_128", "value": "CODE_128" },
    { "label": "DATA_MATRIX", "value": "DATA_MATRIX" },
    { "label": "EAN_8", "value": "EAN_8" },
    { "label": "EAN_13", "value": "EAN_13" },
    { "label": "ITF", "value": "ITF" },
    { "label": "PDF_417 (not supported in iOS)", "value": "PDF_417" },
    { "label": "QR_CODE", "value": "QR_CODE" },
    { "label": "RSS14 (not supported in iOS)", "value": "RSS14" },
    { "label": "RSS_EXPANDED (not supported in iOS)", "value": "RSS_EXPANDED" },
    { "label": "UPC_E", "value": "UPC_E" },
    { "label": "UPC_A", "value": "UPC_A" }];
const nativeMobileBackgroundProps = {
    "hint": {"show": false},
    "backgroundgradient": {"show": false},
    "backgroundattachment": {"show": false},
    "borderstyle": {"type": "list", "options": ["", "dashed", "dotted", "solid"], "value" : ""}
    };
const nativeMobileClassListPickerProps = {
    "class": { "type": "string", "pattern": classRegex },
};

export function getPropertyGroups() {
  return propertyGroups;
}

export function getResultProperties() {
  return {
  "wm.base": {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "deferload": { "type": "boolean", "value": false, "show": false },
    "class": { "type": "string", "pattern": classRegex },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'block' }
  },

  "wm.accessibility_basic.native_mobile": {
    "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint" },
    "accessible": { "type": "boolean", "value": true, "bindable": "in-bound", "displayName": "Accesssibile" },
  },

  "wm.base.mobile": {
    "showindevice": { "type": "select-all", "options": showInDeviceOptionsForMobile, "value": "all", "displaytype": 'block' }
  },
  "wm.base.native_mobile": {
    "showindevice": { "type": "select-all", "options": showInDeviceOptionsForMobile, "value": "all", "displaytype": 'block' }
  },
  "wm.base.editors": {
    "width": { "type": "string", "pattern": dimensionRegex },
    "hint": { "type": "string", "bindable": "in-bound" },
    "height": { "type": "string", "pattern": dimensionRegex },
    "margin": { "type": "string", "widget": "box-model" },
    "fontweight": { "type": "string", "options": ["bold"], "hidelabel": true, "widget": "toggle-checkbox" },
    "fontsize": { "type": "number", "hint": "Font size", "pattern": numberRegex },
    "fontunit": { "type": "string", "options": ["em", "px", "pt"], "value": "px", "hidelabel": true, "widget": "icons-radio", "show": !isNativeMobileApplicationType },
    "textalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" },
    "fontstyle": { "type": "string", "options": ["italic"], "widget": "toggle-checkbox" },
    "textdecoration": { "type": "string", "options": ["underline"], "hidelabel": true, "widget": "toggle-checkbox" },
    "fontfamily": { "type": "string", "hint": "Arial, Geneva" },
    "color": { "type": "string", "widget": "color" }
  },
  "wm.base.reusablewidget": {
    "onAttach": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDetach": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  "wm.base.advancedformwidgets": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" },
    "margin": { "type": "string", "widget": "box-model" },
    "fontweight": { "type": "string", "options": ["bold"], "hidelabel": true, "widget": "toggle-checkbox" },
    "fontsize": { "type": "number", "hint": "Font size", "pattern": numberRegex },
    "fontunit": { "type": "string", "options": ["em", "px", "pt"], "value": "px", "hidelabel": true, "widget": "icons-radio", "show": !isNativeMobileApplicationType },
    "textalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" },
    "textdecoration": { "type": "string", "options": ["underline"], "hidelabel": true, "widget": "toggle-checkbox" },
    "fontstyle": { "type": "string", "options": ["italic"], "widget": "toggle-checkbox" },
    "fontfamily": { "type": "string", "hint": "Arial, Geneva" },
    "color": { "type": "string", "widget": "color" },
    "borderwidth": { "type": "string", "widget": "box-model" },
    "borderstyle": { "type": "string", "options": ["dashed", "dotted", "none", "solid"], "widget": "border-style" },
    "bordercolor": { "type": "string", "widget": "color" },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "display": { "type": "list", "options": displayOptions, "show": false }
  },
  "wm.base.advancedformwidgets.native_mobile": nativeMobileBackgroundProps,
  "wm.base.editors.abstracteditors": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "disabled": { "type": "boolean", "bindable": "in-bound" },
    "required": { "type": "boolean", "bindable": "in-bound" },
    "tabindex": { "type": "number", "value": "0" },
    "onClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onTap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onFocus": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBlur": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  "wm.base.editors.dataseteditors": {
    "startupdate": { "type": "boolean" },
    "datafield": { "type": "list", "options": ["All Fields"], "datasetfilter": "terminals", "allfields": true },
    "displayfield": { "type": "list", "options": [""], "datasetfilter": "terminals" },
    "displayexpression": { "type": "string", "bindable": "in-bound", "bindonly": "expression" },
    "displaytype": { "type": "list", "options": ["Currency", "Date", "Number", "Text", "Time"] },
    "orderby": { "type": "list", "widget": "order-by", "datasetfilter": "terminals" }
  },
  "wm.base.navigation": {
    "navigation": { "type": "list", "options": ["Basic", "Pager", "Classic"], "value": "Basic" },
    "showrecordcount": { "type": "boolean" },
    "maxsize": { "type": "number", "value": 3, "show": false },
    "boundarylinks": { "type": "boolean", "value": false, "show": false },
    "forceellipses": { "type": "boolean", "value": true, "show": false },
    "directionlinks": { "type": "boolean", "value": true, "show": false },
    "navigationalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "value": "left" }
  },
  "wm.base.events": {
    "onTap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDoubletap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onLongtap": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "onClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDblclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  "wm.base.events.native_mobile": {
    "onTouchstart": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "onTouchend": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
  },


  "wm.base.events.touch": {
    "onSwipeup": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSwipedown": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSwipeleft": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSwiperight": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onPinchin": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onPinchout": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },

  "wm.base.events.keyboard": {
    "onKeypress": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onKeydown": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onKeyup": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  "wm.base.events.focus": {
    "onFocus": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBlur": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },

  "wm.base.events.change": {
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },

  "wm.base.events.successerror": {
    "onSuccess": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onError": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },

  "wm.abstractinput": {
    "type": { "type": "string", "value": "text" }
  },

  "wm.html": {
    "content": { "type": "string", "bindable": "in-out-bound", "widget": "textarea" },
    "textalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "show": false },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.icon": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "iconposition": { "type": "list", "options": ["left", "right"], "value": "left" },
    "iconclass": { "type": "string", "value": "wm-sl-l sl-user", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "iconsize": { "type": "string", "pattern": dimensionRegex, "hideInPrism" : true },
    "animation": { "type": "list", "options": animationOptions },
    "color": { "type": "string", "widget": "color" },
    "opacity": { "type": "string", "widget": "slider" }
  },
  "wm.icon.native_mobile": {
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "showskeleton":  {"type": "boolean", "value": false},
    "arialabel": { "show": false},
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role", "value": "none"},
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.iframe": {
    "iframesrc": { "type": "string", "bindable": "in-bound", "widget": "string" },
    "encodeurl": { "type": "boolean", "value": false },
    "width": { "type": "string", "value": '300px', "pattern": dimensionRegex },
    "height": { "type": "string", "value": '150px', "pattern": dimensionRegex },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all" },
    "hint": { "type": "string", "bindable": "in-bound" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.webview": {
    "webviewsrc": { "type": "string", "bindable": "in-bound", "widget": "string" },
    "title": { "type": "string", "bindable": "out-bound", "showPrettyExprInDesigner": true },
    "width": { "type": "string", "value": '300px', "pattern": dimensionRegex },
    "height": { "type": "string", "value": '150px', "pattern": dimensionRegex },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all" },
    "onLoad": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  "wm.bottomsheet": {
    "showonrender": { "type": "boolean","value": false, "bindable": "in-bound",},
    "bottomsheetheightratio": { "type": "string", "value": '0.5', "pattern": dimensionRegex },
    "expand": { "type": "boolean","value": false,  "bindable": "in-bound",},
    "bottomsheetexpandedheightratio": { "type": "string", "value": '0.8', "pattern": dimensionRegex, "show": false },
    "autoclose": { "type": "list", "widget": "select-by-object", "value": "outsideClick", "options": [{ "label": "Outside Click", "value": "outsideClick" },{ "label": "Disabled", "value": "disabled" }] },
    "disableswipedownclose": { "type": "boolean","value": false,  "bindable": "in-bound",},
    "bottomsheetminimumheight": { "type": "string", "value": '0.1', "pattern": dimensionRegex, "show": false  },
    "enabledragsettle": { "type": "boolean","value": false,  "bindable": "in-bound",},
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all" },
    "onClose": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onOpened": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDraghandleiconclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onExpand": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onCollapse": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "disablescrollonrest": { "type": "boolean","value": false,  "bindable": "in-bound",},
  },
  "wm.dynamicstyles": {
    "conditionalstyle": { "bindable": "in-bound", "bindContext": "expression" },
    "conditionalclass": { "bindable": "in-bound", "bindContext": "expression" }
  },
  "wm.dynamicstyles.native_mobile": {
    "conditionalstyle": { "bindable": "in-bound", "bindContext": "expression", "show": false },
    "conditionalclass": { "bindable": "in-bound", "bindContext": "expression" }
  },
  "wm.button": {
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "badgevalue": { "type": "string", "bindable": "in-out-bound", "showPrettyExprInDesigner": true },
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "iconurl": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconwidth": { "type": "string", "pattern": dimensionRegex },
    "iconheight": { "type": "string", "pattern": dimensionRegex },
    "iconmargin": { "type": "string", "pattern": dimensionRegex },
    "iconposition": { "type": "list", "options": ["left", "top", "right"] },
    "disabled": { "type": "boolean", "bindable": "in-bound" },
    "type": { "type": "list", "options": ["button", "reset", "submit"], "value": "button" },
    "tabindex": { "type": "number", "value": "0" },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'inline-block' },
    "animation": { "type": "list", "options": animationOptions },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "value": "btn-default", "options": ["btn-default", "btn-primary", "btn-info", "btn-warning", "btn-success", "btn-danger", "btn-inverse", "btn-lg", "btn-sm", "btn-xs", "btn-raised", "btn-fab", "btn-link", "btn-transparent", "no-border", "jumbotron", "app-header-action"] },
    "margin": { "type": "string", "widget": "box-model" },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "show": false },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.button.native_mobile": {
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "badgevalue": { "show": false },
    "type": { "show": false },
    "onFocus": { "show": false },
    "onBlur": { "show": false },
    "onKeydown": { "show": false },
    "onKeypress": { "show": false },
    "onKeyup": { "show": false },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "showskeleton":  {"type": "boolean", "value": false},
    "arialabel":{"show":false },
    "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint" },
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "button" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.rating": {
    "hint": { "show": false },
    "maxvalue": { "type": "number", "value": 5, "pattern": maxRatingRegex, "bindable": "in-bound" },
    "readonly": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "datavalue": { "type": "number", "bindable": "in-out-bound" },
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "show": false },
    "iconsize": { "type": "string", "pattern": dimensionRegex },
    "activeiconclass": { "type": "string", "value": "wi wi-star", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Active Icon Class" },
    "inactiveiconclass": { "type": "string", "value": "wi wi-star-border", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Inactive Icon Class" },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "width": { "type": "string", "pattern": dimensionRegex, "show": false },
    "height": { "type": "string", "pattern": dimensionRegex, "show": false },
    "tabindex": { "type": "number", "value": "0" },
    "iconcolor": { "type": "string", "widget": "color" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "datafield": { "type": "list", "options": [""], "value": "", "datasetfilter": "terminals" },
    "displayfield": { "type": "list", "options": [""], "datasetfilter": "terminals" },
    "displayexpression": { "type": "string", "bindable": "in-bound", "bindonly": "expression" },
    "showcaptions": { "type": "boolean", "value": true }
  },
   "wm.rating.native_mobile":{
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "radiogroup" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
   },

  "wm.camera": {
    "capturetype": { "type": "list", "options": ["IMAGE", "VIDEO"], "value": "IMAGE" },
    "datavalue": { "type": "string", "value": "", "bindable": "in-bound" },
    "localFilePath": { "type": "string", "value": "", "bindable": "out-bound" },
    "localFile": { "type": "string", "value": "", "bindable": "out-bound" },
    "iconclass": { "type": "string", "value": "wm-sl-l sl-camera", "widget": "select-icon", "bindable": "in-bound", "pattern": classRegex },
    "iconsize": { "type": "string", "pattern": dimensionRegex, "value": "2em" },
    /* capture picture options*/
    "imagequality": { "type": "number", "value": 80 },
    "imageencodingtype": { "type": "list", "options": ["JPEG", "PNG"], "value": "JPEG" },
    "savetogallery": { "type": "boolean", "value": false },
    "allowedit": { "type": "boolean", "value": false },
    "correctorientation": { "type": "boolean", "value": false },
    "imagetargetwidth": { "type": "number" },
    "imagetargetheight": { "type": "number" },
    /* Events */
    "onSuccess": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex }
  },
  "wm.camera.native_mobile": {
    "savetogallery": { "show": false },
    "correctorientation": { "show": false },
    "localFile": { "show": false },
    "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint", "value":"Click to open the camera" },
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": { evaulateBindings: true, handleEmptyEvaluation: true } },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "imagebutton" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.barcodescanner": {
    "datavalue": { "type": "string", "bindable": "in-out-bound" },
    "barcodeformat": { "type": "select-by-object", "options": barcodeFormatOptions, "value": "ALL" },
    "caption": { "type": "string", "value": "", "bindable": "in-bound", "maxlength": 256, "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "value": "glyphicon glyphicon-barcode", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "iconsize": { "type": "string", "pattern": dimensionRegex, "value": "2em" },
    /* Events */
    "onSuccess": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "width": { "type": "string", "pattern": dimensionRegex, "show": false },
    "height": { "type": "string", "pattern": dimensionRegex, "show": false }
  },
  "wm.barcodescanner.native_mobile": {
  "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint", "value":"Click to open the barcode scanner" },
  "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "imagebutton" },
  "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.buttongroup": {
    "width": { "type": "string", "pattern": dimensionRegex },
    "vertical": { "type": "boolean" },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["btn-group-lg", "btn-group-sm", "btn-group-xs", "btn-group-raised", "btn-toolbar", "btn-group-vertical"] },
    "addchild": { "hidelabel": true, "options": [{ "labelKey": "LABEL_ADD_BUTTON", "label": "Add Button", "widgettype": "wm-button", "defaults": { "margin": "" } }], "widget": "add-widget" }
  },
  "wm.buttongroup.native_mobile": {
    "horizontalalign": { "show": false },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "showskeleton":  {"type": "boolean", "value": false}
  },
  "wm.switch": {
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "datavalue": { "type": "string, object", "bindable": "in-out-bound", "widget": "string", "getTypeFrom": "dataset" },
    "dataset": { "type": "array, string", "bindable": "in-bound", "widget": "string", "value": "yes, no, maybe", "showPrettyExprInDesigner": true, "defaultvalue": "yes, no, maybe" },
    "datafield": { "type": "list", "options": ["All Fields"], "value": "", "datasetfilter": "terminals", "allfields": true },
    "displayfield": { "type": "list", "options": [""], "value": "", "datasetfilter": "terminals" },
    "displayexpression": { "type": "string", "bindable": "in-bound", "bindonly": "expression" },
    "compareby": { "type": "list", "widget": "select-all", "datasetfilter": "terminals", "show": false },
    "iconclass": { "type": "list", "options": [""], "value": "", "datasetfilter": "terminals" },
    "multiple": { "type": "boolean", "value": false },
    "checkediconclass": { "type": "string", "value": "", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "tabindex": { "type": "number", "value": "0" },
    "orderby": { "type": "list", "widget": "order-by", "datasetfilter": "terminals" },
    "margin": { "type": "string", "widget": "box-model" },
    "onFocus": { "show": false },
    "onBlur": { "show": false },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.switch.native_mobile": {
    "datafield": { "type": "list", "options": ["All Fields"], "value": "", "datasetfilter": "terminals", "allfields": true },
    "orderby": { "show": false },
    "arialabel":{"show":false },
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label", "value": "Select an option" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role" },
  },
  "wm.menu": {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "value": "Menu Item 1, Menu Item 2, Menu Item 3" },
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "menulayout": { "type": "list", "options": ["vertical", "horizontal"], "hideInPrism" : true },
    "menuclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["btn-default", "btn-primary", "btn-info", "btn-danger", "btn-warning", "btn-success", "btn-lg", "btn-sm", "btn-xs", "btn-link", "btn-transparent", "jumbotron", "app-header-action"] },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "menuposition": { "type": "list", "options": ["", "down,right", "down,left", "up,right", "up,left", "inline"], "value": "" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "linktarget": { "type": "list", "options": ["_blank", "_parent", "_self", "_top"], "widget": "data-list" },
    "tabindex": { "type": "number", "value": "0" },
    "animateitems": { "type": "list", "options": ['', 'slide', 'fade', 'scale'] },
    "shortcutkey": { "type": "string" },
    "orderby": { "type": "list", "widget": "order-by", "datasetfilter": "terminals", "show": false, "showondataset": true },
    "class": { "type": "string", "pattern": classRegex, "show": false },
    "autoclose": { "type": "list", "widget": "select-by-object", "value": "outsideClick", "options": [{ "label": "Outside Click", "value": "outsideClick" }, { "label": "Always", "value": "always" }, { "label": "Disabled", "value": "disabled" }] },
    "autoopen": { "type": "list", "widget": "select-by-object", "value": "never", "options": [{ "label": "Never", "value": "never" }, { "label": "Always", "value": "always" }, { "label": "Active Page", "value": "activepage" }] },
    "showonhover": {"type": "boolean", "value": false, "bindable": "in-bound"},
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.menu.native_mobile": {
    "menulayout": { "show": false },
    "menuposition": { "show": false },
    "linktarget": { "show": false },
    "tabindex": { "show": false },
    "orderby": { "show": false },
    "autoclose": { "show": false },
    "autoopen": { "show": false },
    "showonhover": {"show": false},
    "arialabel": { "show": false },
    "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint " },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "button" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },

  "wm.menu.dataProps": {
    "itemlabel": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals", "show": false, "showondataset": true },
    "itemlink": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals", "show": false, "showondataset": true },
    "itemclass": { "type": "string", "show": false, "showondataset": true },
    "itemicon": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals", "show": false, "showondataset": true },
    "itemchildren": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "objects", "show": false, "showondataset": true },
    "itemaction": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals", "show": false, "showondataset": true },
    "userrole": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals", "show": false, "showondataset": true },
    "isactive": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals", "show": false, "showondataset": true },
  },
  "wm.menu.dataProps.native_mobile": {
    "userrole": { "show": false, "hidelabel": true },
    "itemaction": { "show": false, "hidelabel": true },
    "isactive": { "show": false, "hidelabel": true },
    "orderby": { "show": false, "hidelabel": true },
    "autoclose": { "show": false, "hidelabel": true },
    "autoopen": { "show": false, "hidelabel": true }
  },
  "wm.tree": {
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "value": "node1, node2, node3", "bindInfo": {evaulateBindings: true, invokeVariable: true}},
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onExpand": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onCollapse": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "selecteditem": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "getTypeFrom": "dataset" },
    "treeicons": { "type": "list", "widget": "list", "options": ["folder", "plus-minus", "circle-plus-minus", "chevron", "menu", "triangle", "expand-collapse"] },
    "nodelabel": { "type": "string", "widget": "list", "datasetfilter": "terminals", "bindable": "in-bound", "bindonly": "expression", "show": false, "showondataset": true },
    "nodeicon": { "type": "string", "widget": "list", "datasetfilter": "terminals", "bindable": "in-bound", "bindonly": "expression", "show": false, "showondataset": true },
    "nodechildren": { "type": "string", "widget": "list", "datasetfilter": "objects", "bindable": "in-bound", "bindonly": "expression", "show": false, "showondataset": true },
    "nodeid": { "type": "string", "widget": "list", "datasetfilter": "terminals", "bindable": "in-bound", "bindonly": "expression", "show": false, "showondataset": true },
    "nodeaction": { "type": "string", "widget": "list", "datasetfilter": "terminals", "bindable": "in-bound", "bindonly": "expression", "show": false, "showondataset": true },
    "nodeclick": { "type": "select-by-object", "value": "none", "options": [{ "labelkey": "LABEL_EXPAND_NODE", "value": "expand" }, { "labelkey": "LABEL_DO_NOTHING", "value": "none" }], "show": false, "showondataset": true },
    "tabindex": { "type": "number", "value": "0" },
    "levels": { "type": "number", "value": 0, "min": "0", "max": "10", "step": "1" },
    "datavalue": { "type": "string, number, boolean, date, time, object", "bindable": "in-out-bound", "widget": "tree-datavalue", "getTypeFrom": "expr:getDataValueType()" },
    "orderby": { "type": "list", "widget": "order-by", "datasetfilter": "terminals", "show": false, "showondataset": true }
  },

  "wm.text": {
    "autofocus": { "type": "boolean" },
    "autocomplete": { "type": "boolean", "value": true },
    "autotrim": { "type": "boolean", "value": true },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "updateon": { "type": "list", "value": "blur", "widget": "update-on" },
    "updatedelay": { "type": "number", "value": 0 },
    "type": { "type": "list", "options": ["color", "date", "datetime-local", "email", "month", "number", "password", "search", "tel", "text", "time", "url", "week"], "value": "text" },
    "accept": { "type": "data-list", "options": ["image/*", "audio/*", "video/*"], "show": false },
    "datavalue": { "type": "string", value: "", "bindable": "in-out-bound", "getTypeFrom": "expr:getPropertyType('datavalue')" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-lg", "input-sm"] },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "autocapitalize": {"type": "list", "value": "none", "options": ["characters", "words", "sentences", "none"], "bindable": "in-bound"},
    /* Properties: Validation */
    "regexp": { "type": "string", "value": ".*" },

    /* Properties: help */
    "placeholder": { "type": "string", "value": "Enter text", "bindable": "in-bound" },

    /* Properties: Behavior */
    "maxchars": { "type": "number", "bindable": "in-bound" },

    /*  ---Events---  */
    "changeOnkey": { "type": "boolean" },

    /* Number properties */
    "minvalue": { "type": "string", "bindable": "in-bound" },
    "maxvalue": { "type": "string", "bindable": "in-bound" },
    "step": { "type": "number" },
    "shortcutkey": { "type": "string" },
    "showdisplayformaton": { "type": "select-by-object", "options": [{ "label": "Always", "value": "always" }, { "label": "On keypress", "value": "keypress" }], "value": "always", "show": false },
    "displayformat": { "type": "string", "options": ["999-99-9999", "(999) 999-9999", "(999) 999-9999 ext. 999", "(999) 999-9999 ext. ?9?9?9", "(?9?9?9) ?9?9?9-?9?9?9?9", "(999) 999-9999 ext. 999", "(**: AAA-999)", "9999 9999 9999 9999", "AA-9999"], "widget": "data-list", "bindable": "in-bound", "show": false },
    "leadingiconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "trailingiconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex},
    "supportingtext": { "type": "string", "bindable": "in-bound" },
    "onTrailingIconClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onLeadingIconClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
  },

  "wm.text.native_mobile": {
    "type": { "type": "list", "options": ["email", "number", "password", "tel", "text"], "value": "text" },
    "updatedelay": { "show": false, "ignore": true },
    "displayformat": { "show": false, "ignore": true },
    "onTap": { "show": false },
    "onKeydown": { "show": false },
    "onKeyup": { "show": false },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "autocapitalize": {"type": "list", "value": "none", "options": ["characters", "words", "sentences", "none"], "bindable": "in-bound"},
    "returnkeytype": {"type": "list", "value": "auto", "options": ["auto", "next", "done"], "bindable": "in-bound"},
    "accessibilityrole": { "show": true, "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "none" },
    "accessibilitylabel": { "show": true, "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
    "arialabel":{"show":false},
    "autocomplete": {"show": true,"type": "select-by-object","options": [{ "label": "Username", "value": "username" },{ "label": "Email", "value": "email" }, { "label": "OTP", "value": "one-time-code" },{ "label": "Off", "value": "off" }], "bindable": "in-bound", "value": "username"},
    "skipscripteventtrigger": {"type": "boolean", "value": "false", "bindable": "in-bound"},
  },

  "wm.number": {
    "autofocus": { "type": "boolean" },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "datavalue": { "type": "number", "bindable": "in-out-bound" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-lg", "input-sm"] },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "updateon": { "type": "list", "value": "blur", "widget": "update-on" },
    "step": { "type": "number" },
    "trailingzero": { "type": "boolean", "bindable": "in-bound" },
    "inputmode": { "type": "list", "value": "natural", "options": ["natural", "financial"] },
    "decimalplaces": { "type": "number", "show": false },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },

    /* Properties: Validation */
    "regexp": { "type": "string", "value": ".*" },
    /* Properties: help */
    "placeholder": { "type": "string", "value": "Enter Number", "bindable": "in-bound" },

    /* Number properties */
    "minvalue": { "type": "number", "bindable": "in-bound" },
    "maxvalue": { "type": "number", "bindable": "in-bound" },
    "shortcutkey": { "type": "string" }
  },
  "wm.number.native_mobile": {
    "trailingzero": { "show": false },
    "onTap": { "show": false },
    "onKeydown": { "show": false },
    "onKeyup": { "show": false },
    "inputmode": { "show": false },
    "arialabel": {"show":false },
    "skipscripteventtrigger": {"type": "boolean", "value": "false", "bindable": "in-bound"},
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "none" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },

  "wm.currency": {
    "datavalue": { "type": "number", "bindable": "in-out-bound" },
    "minvalue": { "type": "number", "bindable": "in-bound" },
    "maxvalue": { "type": "number", "bindable": "in-bound" },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "step": { "type": "number" },
    "trailingzero": { "type": "boolean", "bindable": "in-bound" },
    "inputmode": { "type": "list", "value": "natural", "options": ["natural", "financial"] },
    "updateon": { "type": "list", "value": "blur", "widget": "update-on" },
    "currency": { "type": "list", "value": "USD", "options": ["AED", "AFN", "ALL", "AMD", "ARS", "AUD", "AZN", "BAM", "BDT", "BGN", "BHD", "BIF", "BND", "BOB", "BRL", "BWP", "BYR", "BZD", "CAD", "CDF", "CHF", "CLP", "CNY", "COP", "CRC", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EEK", "EGP", "ERN", "ETB", "EUR", "GBP", "GEL", "GHS", "GNF", "GTQ", "HKD", "HNL", "HRK", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KHR", "KMF", "KRW", "KWD", "KZT", "LBP", "LKR", "LTL", "LVL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MOP", "MUR", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SDG", "SEK", "SGD", "SOS", "SYP", "THB", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "UYU", "UZS", "VEF", "VND", "XAF", "XOF", "YER", "ZAR", "ZMK"] },
    /* Properties: help */
    "placeholder": { "type": "string", "value": "Enter value", "bindable": "in-bound" },
    /* Style: Basic */

    "backgroundcolor": { "type": "string", "widget": "color" },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-group-sm", "input-group-lg"] },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.currency.native_mobile": {
    "trailingzero": { "show": false },
    "inputmode": { "show": false },
    "onTap": { "show": false },
    "arialabel":{"show":false },
    "skipscripteventtrigger": {"type": "boolean", "value": "false", "bindable": "in-bound"},
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "none" },
  },
  "wm.base.datetime": {
    "datavalue": { "type": "string", "bindable": "in-out-bound" },
    "tabindex": { "type": "number", "value": "0" },
    "showdropdownon": { "type": "select-by-object", "options": [{ "label": "Default(Input & Button)", "value": "default" }, { "label": "Button Only", "value": "button" }], "value": "default" },
    "dataentrymode": { "type": "select-by-object", "options": [{ "label": "Default (Date/DateTime/Time Picker & Input)", "value": "default" }, { "label": "Date/DateTime/Time Picker Only", "value": "picker" }], "value": "default" },
    /* ---- styles ----*/

    "margin": { "type": "string", "widget": "box-model" },
    "color": { "type": "string", "widget": "color" }
  },
  "wm.date": {
    "placeholder": { "type": "string", "value": "Select date", "bindable": "in-bound" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "autofocus": { "type": "boolean" },
    "showweeks": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "disabled": { "type": "boolean", "bindable": "in-bound" },
    "showdateformatasplaceholder": { "type": "boolean", "value": false},
    "mindate": { "type": dateTimeTypes, "widget": "data-list", "options": ["CURRENT_DATE"], "bindable": "in-bound", "hint": "yyyy-MM-dd" },
    "maxdate": { "type": dateTimeTypes, "widget": "data-list", "options": ["CURRENT_DATE"], "bindable": "in-bound", "hint": "yyyy-MM-dd" },
    "datepattern": { "type": "list", "options": [], "widget": "date-patterns", "value": "MMM d, y", "bindable": "in-bound" },
    "outputformat": { "value": "yyyy-MM-dd", "type": "list", "options": [], "widget": "date-patterns", "bindable": "in-bound" },
    "datavalue": { "type": dateTimeTypes, "widget": "data-list", "options": ["CURRENT_DATE"], "bindable": "in-out-bound", "hint": "yyyy-MM-dd" },
    "timestamp": { "type": dateTimeTypes, "widget": "string", "show": "false", "bindable": "out-bound" },
    "excludedays": { "type": "select-all", "options": dayOptions, "displaytype": "block", "value": " " },
    "excludedates": { "type": "datetime, timestamp, date, array, string", "bindable": "in-bound", "widget": "string", "hint": "yyyy-MM-dd" },
    "tabindex": { "type": "number", "value": "0" },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-group-sm", "input-group-lg"] },
    "showbuttonbar": { "type": "boolean", "value": true, "show": false },
    "onBeforeload": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "viewmode": {"type": "list", "options":['day', 'month'], "value":"day" }
  },

  "wm.date.native_mobile": {
    "autofocus": { "show": false },
    "disabled": { "show": false },
    "showcustompicker": { "show": false },
    "showdropdownon": { "show": false },
    "dataentrymode": { "show": false },
    "showdateformatasplaceholder": { "show": false },
    "dateheadertitle": {"type": "string", "value": "Select date"},
    "dateconfirmationtitle": {"type": "string", "value": "Select"},
    "datecanceltitle": {"type": "string", "value": "Cancel"},
    "arialabel":{"show":false },
    "viewmode": {"show": false},
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.calendar": {
    "backgroundcolor": { "type": "string", "widget": "color" },
    "width": { "type": "string", "value": "100%", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "selectionmode": { "type": "list", "widget": "select-by-object", "value": "none", "options": [{ "label": "None", "value": "none" }, { "label": "Single", "value": "single" }, { "label": "Multiple", "value": "multiple" }] },
    "selecteddates": { "type": "object", "widget": "string", "bindable": "in-out-bound", "getTypeFrom": "expr:getPropertyType('selecteddates')" },
    "currentview": { "type": "object", "widget": "string", "bindable": "in-out-bound", "getTypeFrom": "expr:getPropertyType('currentview')" },
    "selecteddata": { "type": "array, object", "isList": true, "show": false, "bindable": "out-bound", "getTypeFrom": "dataset" },
    "calendartype": { "type": "list", "options": ["basic", "agenda", "list"], "value": "basic" },
    "eventstart": { "type": "list", "value": "start", "options": [""], "datasetfilter": "terminals" },
    "eventend": { "type": "list", "value": "end", "options": [""], "datasetfilter": "terminals" },
    "eventallday": { "type": "list", "value": "allday", "options": [""], "datasetfilter": "terminals" },
    "eventtitle": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" },
    "eventclass": { "type": "list", "value": "class", "options": [""], "datasetfilter": "terminals" },
    "view": { "type": "list", "options": ["month", "week", "day"], "value": "month" },
    "controls": { "type": "list", "options": "navigation, today, month, week, day", "value": "navigation, today, month, week, day", "widget": "select-all" },
    "onEventdrop": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onEventresize": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onEventrender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onViewrender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onEventclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforerender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDateclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "tabindex": { "type": "number", "value": "0" },
    "showdropdownon": { "show": false },
    "dataentrymode": { "show": false }
  },
  // "wm.calendar.native_mobile": {
  //   "onEventclick": { "show": false },
  //   "height": { "show": false },
  //   "width": { "show": false },
  //   "view": { "show": false }
  // },
  "wm.calendar.native_mobile": {
    "onEventclick": { "show": false },
    "onEventrender": { "show": false },
    "height": { "show": false },
    "width": { "show": false },
    "view": { "show": false },
    "controls": {"show": false},
    "calendartype": {"show": false},
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.time": {
    "placeholder": { "type": "string", "value": "Select time", "bindable": "in-bound" },
    "mintime": { "type": "string", "bindable": "in-bound" },
    "maxtime": { "type": "string", "bindable": "in-bound" },
    "autofocus": { "type": "boolean" },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "disabled": { "type": "boolean", "bindable": "in-bound" },
    "hourstep": { "type": "number", "value": 1 },
    "timepattern": { "type": "list", "options": [], "widget": "time-patterns", "value": "h:mm:ss a", "bindable": "in-bound" },
    "minutestep": { "type": "number", "value": 15 },
    "outputformat": { "value": "HH:mm:ss", "type": "list", "options": [], "widget": "time-patterns", "bindable": "in-bound" },
    "required": { "type": "boolean" },
    "datavalue": { "type": "time, date, string, number", "widget": "data-list", "options": ["CURRENT_TIME"], "bindable": "in-out-bound", hint: "HH:mm" },
    "timestamp": { "type": "time, date, string, number", "widget": "string", "show": "false", "bindable": "out-bound" },
    "tabindex": { "type": "number", "value": "0" },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-group-sm", "input-group-lg"] },
    "onBeforeload": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "showampmbuttons":{ "type": "boolean", "bindable": "in-bound" }
  },

  "wm.time.native_mobile": {
    "hourstep": { "type": "number", "value": 1, "show": false },
    "minutestep": { "type": "number", "value": 15, "show": false },
    "autofocus": { "show": false },
    "disabled": { "show": false },
    "mintime": { "show": false },
    "maxtime": { "show": false },
    "showcustompicker": { "show": false },
    "showdropdownon": { "show": false },
    "dataentrymode": { "show": false },
    "timeheadertitle": {"type": "string", "value": "Select time"},
    "timeconfirmationtitle": {"type": "string", "value": "Select"},
    "timecanceltitle": {"type": "string", "value": "Cancel"},
    "arialabel":{"show":false },
    "showampmbuttons":{"show":false },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.datetime": {
    "placeholder": { "type": "string", "value": "Select date time", "bindable": "in-bound" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "autofocus": { "type": "boolean" },
    "showweeks": { "type": "boolean", "value": false },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "disabled": { "type": "boolean", "bindable": "in-bound" },
    "hourstep": { "type": "number", "value": 1 },
    "minutestep": { "type": "number", "value": 15 },
    "mindate": { "type": dateTimeTypes, "widget": "data-list", "options": ["CURRENT_DATE"], "bindable": "in-bound", "hint": "yyyy-MM-dd" },
    "maxdate": { "type": dateTimeTypes, "widget": "data-list", "options": ["CURRENT_DATE"], "bindable": "in-bound", "hint": "yyyy-MM-dd" },
    "datepattern": { "value": "MMM d, y h:mm:ss a", "type": "list", "options": [], "widget": "date-time-patterns", "bindable": "in-bound" },
    "outputformat": { "value": "timestamp", "type": "list", "options": [], "widget": "date-time-patterns", "bindable": "in-bound" },
    "datavalue": { "type": dateTimeTypes, "widget": "data-list", "options": ["CURRENT_DATE"], "bindable": "in-out-bound", "hint": "yyyy-MM-dd HH:mm:ss" },
    "timestamp": { "type": dateTimeTypes, "widget": "string", "show": "false", "bindable": "out-bound" },
    "excludedays": { "type": "select-all", "options": dayOptions, "displaytype": "block", "value": " " },
    "excludedates": { "type": "datetime, timestamp, date, array, string", "bindable": "in-bound", "widget": "string", "hint": "yyyy-MM-dd" },
    "tabindex": { "type": "number", "value": "0" },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-group-sm", "input-group-lg"] },
    "showbuttonbar": { "type": "boolean", "value": true, "show": false },
    "onBeforeload": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "showampmbuttons":{ "type": "boolean", "bindable": "in-bound" }
  },

  "wm.datetime.native_mobile": {
    "hourstep": { "type": "number", "value": 1, "show": false },
    "minutestep": { "type": "number", "value": 15, "show": false },
    "autofocus": { "show": false },
    "disabled": { "show": false },
    "showcustompicker": { "show": false },
    "showdropdownon": { "show": false },
    "dataentrymode": { "show": false },
    "dateheadertitle": {"type": "string", "value": "Select date"},
    "dateconfirmationtitle": {"type": "string", "value": "Select"},
    "datecanceltitle": {"type": "string", "value": "Cancel"},
    "timeheadertitle": {"type": "string", "value": "Select time"},
    "timeconfirmationtitle": {"type": "string", "value": "Select"},
    "timecanceltitle": {"type": "string", "value": "Cancel"},
    "arialabel":{"show":false },
    "showampmbuttons":{"show":false },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.message": {
    "type": { "type": "string", "options": ["error", "info", "loading", "success", "warning"], "value": "success", "bindable": "in-out-bound", "widget": "list", "hideInPrism" : true},
    "caption": { "type": "string", "value": "Message", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "onClose": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "animation": { "type": "list", "options": animationOptions },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "hideclose": { "type": "boolean", "value": false }
  },
  "wm.message.native_mobile": {
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role", "value": "alert" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.composite": {
    "captionposition": { "type": "list", "options": ["left", "right", "top", "floating"] },
    "required": { "type": "boolean" },
    "margin": { "type": "string", "widget": "box-model" }
  },

  "wm.radio": {
    //"readonly": {"type": "boolean", "value": false}, //commenting this property temporarily as it is not working
    "autofocus": { "type": "boolean" },
    "disabled": { "value": false, "bindable": "in-bound" },
    "datavalue": { "type": "string", "bindable": "in-out-bound" },
    "checkedvalue": { "type": "string" },
    "radiogroup": { "type": "string" },
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "shortcutkey": { "type": "string" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "margin": { "type": "string", "widget": "box-model" }
  },
  "wm.radioset": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "margin": { "type": "string", "widget": "box-model" },
    "tabindex": { "type": "number", "value": "0" },
    "disabled": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "readonly": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "itemsperrow": { "type": "string", "widget": "device-config", "widthHeader": "Items per row", "value": "xs-1 sm-1 md-1 lg-1", "deviceHeader": "Device", "deviceSizes": ['1', '2', '3', '4', '6', '12'], "tableClass": "wm-table-dark" },
    "itemclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["list-group", "media-list"] },
    "listclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["list-group-item", "media"] },
    /* ---- events ---- */

    "onClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onTap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onFocus": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onBlur": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },

    "datavalue": { "type": "string, number, boolean, date, time, object", "widget": "string", "bindable": "in-out-bound", "getTypeFrom": "dataset" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "value": "Option 1, Option 2, Option 3", "showPrettyExprInDesigner": true, "defaultvalue": "Option 1, Option 2, Option 3" },
    "usekeys": { "type": "boolean" },
    "required": { "type": "boolean", "bindable": "in-bound", "value": false },
    "groupby": { "type": "list", "show": true, "widget": "list-typeahead", "datasetfilter": "terminals" },
    "match": { "type": "list-group", "nonGroupOptions": timeNonGroupOptions, "options": timeGroupOptions, "show": false, "value": "word", "datasetfilter": "none" },
    "collapsible": { "type": "boolean", "show": false },
    "showcount": { "type": "boolean", "show": false },
    "dateformat": { "type": "list", "options": [], "widget": "date-time-patterns", "show": false },
    "selectedvalue": { "type": "string, number, boolean, date, time, object", "widget": "string", "bindable": "in-bound", "getTypeFrom": "dataset", "show": false },
    "displayValue": { "type": "string", "show": false, "bindable": "out-bound" },
    "compareby": { "type": "list", "widget": "select-all", "datasetfilter": "terminals", "show": false }
  },
  "wm.radioset.native_mobile": {
    "usekeys": { "show": false },
    "showcount": { "show": false },
    "collapsible": { "show": false },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "numberofskeletonitems":{"type": "number", "value": "3"},
    "showskeleton":  {"type": "boolean", "value": false},
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "radiogroup" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label", "value": "Select your preferred option"},
  },
  "wm.colorpicker": {
    "readonly": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "disabled": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "required": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "datavalue": { "type": "string", "bindable": "in-out-bound" },
    "placeholder": { "type": "string", "value": "Select Color", "bindable": "in-bound" },
    "autoclose": { "type": "list", "widget": "select-by-object", "value": "outsideClick", "options": [{ "label": "Outside Click", "value": "outsideClick" }, { "label": "Always", "value": "always" }, { "label": "Disabled", "value": "disabled" }] },
    "tabindex": { "type": "number", "value": "0" },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-group-sm", "input-group-lg"] },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "onDblclick": { "show": false },
    "onDoubletap": { "show": false }
  },

  "wm.inputcolorpicker": {
    "defaultcolor": { "value": "#fff" }
  },

  "wm.inputslider": {
    "caption": { "value": "slider", "maxlength": 256, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} }
  },

  "wm.slider": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "readonly": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "disabled": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "minvalue": { "type": "number", "bindable": "in-out-bound" },
    "maxvalue": { "type": "number", "bindable": "in-out-bound" },
    "step": { "type": "number" },
    "datavalue": { "type": "string, number", "widget": "string", "bindable": "in-out-bound" },
    "tabindex": { "type": "number", "value": "0" },
    "shortcutkey": { "type": "string" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "margin": { "type": "string", "widget": "box-model" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "showmarkers": {"type": "boolean", "value": false, "bindable": "in-bound"},
    "markerlabeltext": {"type": "array, string", "show": true, "bindable": "in-bound"},
    "showicons": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "starticon": { "type": "string", "widget": "select-icon", "value": "wi wi-minus", "bindable": "in-out-bound", "pattern": classRegex},
    "endicon": { "type": "string", "widget": "select-icon", "value": "wi wi-plus", "bindable": "in-out-bound", "pattern": classRegex},
    "rangelabelposition": { "type": "list", "options": ["top", "bottom", "side"], "value": "bottom" },
  },
  "wm.slider.native_mobile": {
    "range": {"type": "boolean", "value": false},
    "showtooltip": {"type": "boolean", "value": false, "bindable": "in-bound"},
    "arialabel":{"show": false },
  },
  "wm.checkbox": {
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "margin": { "type": "string", "widget": "box-model" },
    "datavalue": { "type": "boolean, string", "bindable": "in-out-bound", "widget": "string" },
    "checkedvalue": { "type": "string" },
    "uncheckedvalue": { "type": "string" },
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "shortcutkey": { "type": "string" },
    "readonly": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.checkbox.native_mobile":{
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "arialabel":{"show": false },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "checkbox" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
    "handlesizeon": { "type": "number", "bindable": "in-bound", "value": 1.5, "show": false },
    "handlesizeoff": { "type": "number", "bindable": "in-bound", "value": 1, "show": false },
    "handlesizebounce": { "type": "number", "bindable": "in-bound", "value": 1.6, "show": false },
    "bounceduration": { "type": "number", "bindable": "in-bound", "value": 300, "show": false },
    "slideduration": { "type": "number", "bindable": "in-bound", "value": 300, "show": false },
  },
  "wm.checkboxset": {
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "margin": { "type": "string", "widget": "box-model" },
    "tabindex": { "type": "number", "value": "0" },
    "disabled": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "readonly": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "itemsperrow": { "type": "string", "widget": "device-config", "widthHeader": "Items per row", "value": "xs-1 sm-1 md-1 lg-1", "deviceHeader": "Device", "deviceSizes": ['1', '2', '3', '4', '6', '12'], "tableClass": "wm-table-dark" },
    "itemclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["list-group", "media-list"] },
    "listclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["list-group-item", "media"] },
    "groupby": { "type": "list", "show": true, "widget": "list-typeahead", "datasetfilter": "terminals" },
    "match": { "type": "list-group", "nonGroupOptions": timeNonGroupOptions, "options": timeGroupOptions, "show": false, "value": "word", "datasetfilter": "none" },
    "collapsible": { "type": "boolean", "show": false },
    "showcount": { "type": "boolean", "show": false },
    "dateformat": { "type": "list", "options": [], "widget": "date-time-patterns", "show": false },
    /* ---- events ---- */

    "onClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onTap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onFocus": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onBlur": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },

    "datavalue": { "type": "string, array", "bindable": "in-out-bound", "widget": "string", "getTypeFrom": "dataset" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "value": "Option 1, Option 2, Option 3", "showPrettyExprInDesigner": true, "defaultvalue": "Option 1, Option 2, Option 3", "bindInfo": {evaulateBindings: true, invokeVariable: true} },
    "usekeys": { "type": "boolean" },
    "selectedvalues": { "type": "string, object", "isList": true, "bindable": "in-bound", "widget": "string", "getTypeFrom": "dataset", "show": false },
    "onReady": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "displayValue": { "type": "string, array", "isList": true, "show": false, "bindable": "out-bound" },
    "compareby": { "type": "list", "widget": "select-all", "datasetfilter": "terminals", "show": false },
    "required": { "type": "boolean", "bindable": "in-bound", "value": false }
  },
  "wm.checkboxset.native_mobile": {
    "usekeys": { "show": false },
    "showcount": { "show": false },
    "collapsible": { "show": false },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "numberofskeletonitems":{"type": "number", "value": "3"},
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "combobox" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label", "value": "Select your preferred options"},
  },
  "wm.toggle": {
   "selectedicon": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "value": "" },
   "unselectedicon": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "value": "" }
  },
  "wm.icon_button_toggle": {
    "unselectedicon": { "type": "string", "value": "wm-sl-l sl-volume-full", "widget": "select-icon", "bindable": "in-bound" },
    "selectedicon": { "type": "string", "value": "wm-sl-l sl-volume-off", "widget": "select-icon", "bindable": "in-bound" }
  },
  "wm.chips": {
    "required": { "type": "boolean", "bindable": "in-bound" },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "overflow": { "type": "list", "options": ["visible", "hidden", "scroll", "auto", "initial", "inherit"], "parent": "displaystyle" },
    "inputposition": { "type": "list", "options": ["first", "last"], "value": "last" },
    "inputwidth": { "type": "list", "options": ["default", "full"], "value": "default" },
    "selectionmode": { "type": "list", "options": ["single", "multiple"], "value": "multiple", "displayName": "Selection Mode" },
    "tabindex": { "type": "number", "value": "0" },
    "readonly": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "minchars": { "type": "number", "value": "1" },
    "searchkey": { "type": "string", "widget": "select-all", "datasetfilter": "custom" },
    "datavalue": { "type": "string", "bindable": "in-out-bound", "widget": "string", "getTypeFrom": "dataset" },
    "enablereorder": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "value": "Option 1, Option 2, Option 3" },
    "displayimagesrc": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" },
    "disabled": { "type": "boolean", "bindable": "in-bound" },
    "placeholder": { "type": "string", "value": "Type here...", "bindable": "in-bound" },
    "maxsize": { "type": "number" },
    "allowonlyselect": { "type": "boolean", "value": false },
    "class": { "type": "string", "pattern": classRegex },
    "chipclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "bindable": "in-bound" },
    "selectediconclass": { "type": "string", "value": "wm-sl-l sl-check", "widget": "select-icon", "bindable": "in-bound", "displayName": "Selected Icon Class" },
    "lefticonclass": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "displayName": "Left Icon Class" },
    "righticonclass": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "displayName": "Right Icon Class" },
    "leftbadge": { "type": "string", "bindable": "in-bound", "displayName": "Left Badge" },
    "rightbadge": { "type": "string", "bindable": "in-bound", "displayName": "Right Badge" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforeadd": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onAdd": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforeremove": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onRemove": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforereorder": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onReorder": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onChipselect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onChipclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "autofocus": { "type": "boolean", "value": false },
    "onFocus": { "show": false },
    "onBlur": { "show": false },
    "onBeforeservicecall": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "debouncetime": { "type": "number", "value": "250", "show": true },
    "matchmode": { "type": "select-by-object", "options": matchModes, "value": "startignorecase", "show": false, "showonvariable": "wm.LiveVariable"},
    "groupby": { "type": "list", "show": true, "widget": "list-typeahead", "datasetfilter": "terminals" },
    "match": { "type": "list-group", "nonGroupOptions": timeNonGroupOptions, "options": timeGroupOptions, "show": false, "value": "word", "datasetfilter": "none" },
    "dateformat": { "type": "list", "options": [], "widget": "date-time-patterns", "show": false },
    "datacompletemsg": { "type": "string", "value": "No more data to load", "bindable": "in-bound" },
  },
  "wm.chips.native_mobile": {
    "required":{"show": false},
    "groupby": { "show": false },
    "orderby": { "show": false },
    "debouncetime": { "show": false },
    "allowonlyselect": { "show": false },
    "enablereorder": { "show": false },
    "onBeforeservicecall": { "show": false },
    "onBeforereorder": { "show": false },
    "onReorder": { "show": false },
    "inputwidth": { "show": false },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.select": {
    "autofocus": { "type": "boolean" },
    "readonly": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "datavalue": { "type": "string, number, boolean, date, time, object", "bindable": "in-out-bound", "widget": "string", "getTypeFrom": "dataset", "getIsListFrom": "expr:multiple" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "allownone": { "type": "boolean" },
    "hasdownarrow": { "type": "boolean", "value": true },
    "restrictvalues": { "type": "boolean", "value": true },
    "disabled": { "value": false, "bindable": "in-bound" },
    "multiple": { "type": "boolean", "value": false },
    "placeholder": { "type": "string", "value": "", "bindable": "in-bound" },
    "shortcutkey": { "type": "string" },
    "groupby": { "type": "list", "show": true, "widget": "list-typeahead", "datasetfilter": "terminals" },
    "match": { "type": "list-group", "nonGroupOptions": timeNonGroupOptions, "options": timeGroupOptions, "show": false, "value": "word", "datasetfilter": "none" },
    "dateformat": { "type": "list", "options": [], "widget": "date-time-patterns", "show": false },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-lg", "input-sm"] },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "displayValue": { "type": "string", "getIsListFrom": "expr:multiple", "show": false, "bindable": "out-bound" },
    "compareby": { "type": "list", "widget": "select-all", "datasetfilter": "terminals", "show": false },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.select.native_mobile": {
    "autofocus": { "show": false },
    "readonly": { "show": false },
    "multiple": { "show": false },
    "groupby": { "show": false },
    "orderby": { "show": false },
    "compareby": { "show": false },
    "onTap": { "show": false },
    "onKeydown": { "show": false },
    "onKeyup": { "show": false },
    "onKeypress": { "show": false },
    "arialabel":{"show":false },
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "button" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label", "value": "Select an option" },
  },

  "wm.marquee": {
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "direction": { "type": "list", "options": ["up", "down", "left", "right"], "parent": "behavior" },
    "behavior": { "type": "list", "options": ["scroll", "slide", "alternate"] },
    "scrolldelay": { "type": "number" },
    "scrollamount": { "type": "number" }
  },

  "wm.custom": {
    "height": {"type": "string", "pattern": dimensionRegex},
    "width": {"type": "string", "pattern": dimensionRegex},
    "name": {"type": "string", "pattern": nameRegex, "maxlength": 32},
    "addproperty": { "type": "string", "widget": "add-widget-property"}
  },

  "wm.label": {
    "caption": { "type": "date, string, number", "widget": "string", "value": "Label", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "required": { "type": "boolean" },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'inline-block' },
    "animation": { "type": "list", "options": animationOptions },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["h1", "h2", "h3", "h4", "h5", "h6", "p", "text-ellipsis", "text-left", "text-right", "text-center", "text-muted", "text-primary", "text-success", "text-info", "text-warning", "text-danger", "label-default", "label-primary", "label-success", "label-info", "label-warning", "label-danger", "vertical-align-top", "vertical-align-middle", "vertical-align-bottom", "lead", "badge", "form-control-static", "control-label"] },
    "whitespace": { "type": "list", "options": [" ", "normal", "nowrap", "pre", "pre-line", "pre-wrap"], "value": " " },
    "wordbreak": { "type": "list", "options": ["break-word", "normal"] },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "show": false },
  },

  "wm.label.native_mobile": {
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "textanimation": { "type": "list", "options": textAnimationOptions },
    "animationspeed": { "type": "number", "value": 80 },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "multilineskeleton": {"type": "boolean", "value": false},
    "showskeleton":  {"type": "boolean", "value": false},
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role", "value": "text" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },

  "wm.picture": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "picturesource": { "type": "string", "bindable": "in-out-bound" },
    "pictureplaceholder": { "type": "string", "value": "resources/images/imagelists/default-image.png", "bindable": "in-bound", "widget": "string" },
    "encodeurl": { "type": "boolean", "value": false },
    "pictureaspect": { "type": "list", "options": ["Both", "H", "None", "V"], "value": "None" },
    "disabled": { "type": "boolean", "show": false, "bindable": "in-bound" },
    "tabindex": { "type": "number", "value": "0" },
    "resizemode": { "type": "string", "options": ["cover", "contain"], "widget": "icons-radio" },
    "shape": { "type": "list", "options": ["", "rounded", "circle", "thumbnail"] , "hideInPrism" : true},
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'inline-block' },
    "animation": { "type": "list", "options": animationOptions },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["img-responsive"] },
    "margin": { "type": "string", "widget": "box-model" },
    "borderwidth": { "type": "string", "widget": "box-model" },
    "borderstyle": { "type": "string", "options": ["dashed", "dotted", "none", "solid"], "widget": "border-style" },
    "bordercolor": { "type": "string", "widget": "color" },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "cursor": { "type": "list", "options": ["default", "pointer"] },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "alttext": { "type": "string", "bindable": "in-bound", "displayName":"Alt text" }
  },
  "wm.picture.mobile": {
    "offline": { "type": "boolean", "value": true }
  },
  "wm.picture.native_mobile": {
    "pictureaspect": { "show": false },
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "offline": { "show": false },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "showskeleton":  {"type": "boolean", "value": false},
    "arialabel": {"show": false },
    "backgroundgradient": {"show": false},
    "backgroundattachment": {"show": false},
    "borderstyle": {"type": "list", "options": ["", "dashed", "dotted", "solid"], "value" : ""},
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "aspectratio": {"type": "number"},
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role", "value": "image" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label", "value": "Image" },
  },
  "wm.textarea": {
    "autofocus": { "type": "boolean" },
    "autotrim": { "type": "boolean", "value": true },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "datavalue": { "type": "string", "bindable": "in-out-bound" },
    "placeholder": { "type": "string", "value": "Place your text", "bindable": "in-bound" },
    "maxchars": { "type": "number", "bindable": "in-out-bound" },
    "charlength": { "type": "number", "show": false, "bindable": "out-bound" },
    "limitdisplaytext": { "type": "list", "show": false, "widget": "select-by-object", "bindable": "in-bound", "options": [{ label: "0 characters filled out of 100", value: "bind:Widgets.${name}.charlength + \" characters filled out of \" + Widgets.${name}.maxchars" }, { "label": "100 characters left out of 100", "value": "bind:Widgets.${name}.maxchars - Widgets.${name}.charlength + \" characters left out of \" + Widgets.${name}.maxchars" }, { "label": "0/100", "value": "bind:Widgets.${name}.charlength + \"/\" + Widgets.${name}.maxchars" }] },
    "updateon": { "type": "list", "value": "blur", "widget": "update-on" },
    "updatedelay": { "type": "number", "value": 0 },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-lg", "input-sm"] },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.textarea.native_mobile": {
    "updatedelay": { "show": false },
    "onTap": { "show": false },
    "onKeydown": { "show": false },
    "onKeyup": { "show": false },
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "showskeleton":  {"type": "boolean", "value": false},
    "arialabel": {"show": false},
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "none" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.basicdialog": {
    "show": { "type": "boolean", "show": false },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "onOpened": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "animation": { "type": "list", "options": animationOptions },
    "tabindex": { "type": "number", "value": "0" },
    "headinglevel": { "type": "list", "options": ["h1", "h2", "h3", "h4", "h5", "h6",], "value": "h4" },
    "title": { "type": "string", "maxlength": 256, "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "iconurl": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconwidth": { "type": "string", "pattern": dimensionRegex },
    "iconheight": { "type": "string", "pattern": dimensionRegex },
    "iconmargin": { "type": "string", "pattern": dimensionRegex },
    "actiontitle": { "type": "string", "show": false, "pattern": dimensionRegex },
    "actionlink": { "type": "string", "show": false, "pattern": dimensionRegex },
    "closable": { "type": "boolean", "show": true, "value": true },
    "contentclass": { "type": "string", "pattern": classRegex, "show": false },
    "sheet": { "type": "boolean", "show": true, "value": false, "hideInPrism" : true },
  },
  "wm.basicdialog.native_mobile": {
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    // "headinglevel": { "show": false },
  },
  "wm.dialog.dialogheader": {
    "caption": { "type": "string", "maxlength": 256, "bindable": "in-bound", "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "iconurl": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconwidth": { "type": "string", "pattern": dimensionRegex },
    "iconheight": { "type": "string", "pattern": dimensionRegex },
    "iconmargin": { "type": "string", "pattern": dimensionRegex },
    "closable": { "type": "boolean", "show": true, "value": true }
  },
  "wm.dialog.onOk": {
    "onOk": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },

  "wm.alertdialog": {
    "title": { "type": "string", "value": "Alert", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "oktext": { "type": "string", "value": "OK", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "value": "wi wi-warning", "pattern": classRegex },
    "message": { "type": "string", "value": "I am an alert box!", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "alerttype": { "type": "list", "options": ["error", "information", "success", "warning"], "value": "error" },
    "modal": { "type": "boolean", "value": false, "hideInPrism" : true },
    "keyboard": { "type": "boolean", "value": true, "show": false }
  },
  "wm.confirmdialog": {
    "title": { "type": "string", "value": "Confirm", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "canceltext": { "type": "string", "value": "CANCEL", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "oktext": { "type": "string", "value": "OK", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "value": "wi wi-done", "pattern": classRegex },
    "message": { "type": "string", "value": "I am confirm box!", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "onCancel": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "keyboard": { "type": "boolean", "value": true, "show": false }
  },
  "wm.iframedialog": {
    "title": { "type": "string", "value": "External Content", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "url": { "type": "string", "value": "https://www.wavemaker.com", "bindable": "in-out-bound" },
    "encodeurl": { "type": "boolean", "value": false },
    "height": { "type": "string", "value": "400", "pattern": dimensionRegex },
    "onClose": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "value": "wi wi-globe", "pattern": classRegex },
    "oktext": { "type": "string", "value": "OK", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "closable": { "type": "boolean", "value": true },
    "showactions": { "type": "boolean", "value": true },
    "showheader": { "type": "boolean", "value": true },
    "modal": { "type": "boolean", "value": false, "hideInPrism" : true },
    "keyboard": { "type": "boolean", "value": true, "show": false }
  },
  "wm.page": {
    "cache": { "type": "boolean", "value": false },
    "refreshdataonattach": { "type": "boolean", "value": true, "show": true },
    "onDestroy": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true, "labelKey": "onPageDestroy" },
    "onOrientationchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true },
    "onResize": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true },
    "hint": { "type": "string", "bindable": "in-bound" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.page.native_mobile": {
    "cache": { "type": "boolean", "value": true },
    "onscroll": { "type": "select-by-object", "options": [{ "label": "Default", "value": "none" }, { "label": "Hide top nav", "value": "topnav" },{ "label": "Hide top and bottom nav", "value": "topnav-bottomnav" }], "value": ""},
    "statusbarstyle": { "type": "select-by-object", "options": [{ "label": "Default", "value": "default" }, { "label": "Dark", "value": "dark-content" },{ "label": "Light", "value": "light-content" }], "value": "default"},
    "arialabel": {"show": false },
  },
  "wm.pagedialog": {
    "title": { "type": "string", "value": "Page Content", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound" },
    "oktext": { "type": "string", "value": "OK", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "onClose": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "value": "wi wi-file", "pattern": classRegex },
    "closable": { "type": "boolean", "value": true },
    "showactions": { "type": "boolean", "value": true },
    "modal": { "type": "boolean", "value": false, "hideInPrism" : true },
    "keyboard": { "type": "boolean", "value": true, "show": false }
  },
  "wm.partial": {
    "onDestroy": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true, "labelKey": "onPartialDestroy" },
    "onOrientationchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true },
    "onResize": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true }
  },
  "wm.logindialog": {
    "tabindex": { "show": false },
    "height": { "type": "string", "show": false, "pattern": dimensionRegex },
    "onClose": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "closable": { "type": "boolean", "value": false, "show": false },
    "modal": { "type": "boolean", "value": true, "hideInPrism" : true },
    "keyboard": { "type": "boolean", "value": true, "show": false },
    "onSubmit": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "title": { "type": "string", "maxlength": 256, "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "iconwidth": { "type": "string", "pattern": dimensionRegex },
    "iconheight": { "type": "string", "pattern": dimensionRegex },
    "iconmargin": { "type": "string", "pattern": dimensionRegex }
  },
  "wm.designdialog": {
    "modal": { "type": "boolean", "value": false, "hideInPrism" : true},
    "onClose": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "keyboard": { "type": "boolean", "value": true, "show": false },
    "closable": { "type": "boolean", "value": true },
    "title": { "type": "string" },
    "showheader": { "type": "boolean", "value": true },
    "sheet": { "type": "boolean", "show": true, "value": false },
    "sheetposition": { "type": "list", "options": ["bottom","top", "right", "left"], "show": false, "value": "right" },
  },
  "wm.spinner": {
    "show": { "type": "boolean", "value": false },
    "caption": { "type": "string", "bindable": "in-bound", "value": "Loading...", "maxlength": 256 },
    "servicevariabletotrack": { "type": "list", "options": [], "widget": "multi-select" },
    "iconclass": { "type": "string", "value": "fa fa-circle-o-notch", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "iconsize": { "type": "string", "pattern": dimensionRegex },
    "image": { "type": "string", "bindable": "in-bound","show": false},
    "imagewidth": { "type": "string", "value": "20px" ,"show": false},
    "imageheight": { "type": "string" },
    "animation": { "type": "list", "value": "spin", "options": spinnerAnimationOptions },
    "type": { "type": "list", "value": "icon", "options": ["image", "icon"] },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "color": { "type": "string", "widget": "color" },
    "fontweight": { "type": "string", "options": ["bold"], "hidelabel": true, "widget": "toggle-checkbox" },
    "fontsize": { "type": "number", "hint": "Font size", "pattern": numberRegex },
    "fontunit": { "type": "string", "options": ["em", "px", "pt"], "value": "px", "hidelabel": true, "widget": "icons-radio", show: !isNativeMobileApplicationType },
    "textdecoration": { "type": "string", "options": ["underline"], "hidelabel": true, "widget": "toggle-checkbox" },
    "fontstyle": { "type": "string", "options": ["italic"], "widget": "toggle-checkbox" },
    "fontVariant": { "type": "list", "options": ["normal", "small-caps"] },
    "fontfamily": { "type": "string", "hint": "Arial, Geneva" },
    "hint": { "type": "string", "bindable": "in-bound" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.spinner.native_mobile": {
    "servicevariabletotrack": { "show": false },
    "animation": { "show": false },
    "arialabel":{"show":false },
    "backgroundgradient": {"show": false},
    "backgroundattachment": {"show": false},
    "borderstyle": {"type": "list", "options": ["", "dashed", "dotted", "solid"], "value" : ""}
  },
  'wm.layouts': {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "class": { "type": "string", "pattern": classRegex },
    "borderwidth": { "type": "string", "widget": "box-model" },
    "borderstyle": { "type": "string", "options": ["dashed", "dotted", "none", "solid"], "widget": "border-style" },
    "bordercolor": { "type": "string", "widget": "color" },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "color": { "type": "string", "widget": "color" },
    "overflow": { "type": "list", "options": ["visible", "hidden", "scroll", "auto", "initial", "inherit"], "parent": "displaystyle" },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE }
  },
  "wm.layouts.native_mobile": nativeMobileBackgroundProps,
  'wm.containers': {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "class": { "type": "string", "pattern": classRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "deferload": { "type": "boolean", "value": false, "show": false },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'block' },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "color": { "type": "string", "widget": "color" },
    "fontweight": { "type": "string", "options": ["bold"], "hidelabel": true, "widget": "toggle-checkbox" },
    "fontsize": { "type": "number", "hint": "Font size", "pattern": numberRegex },
    "fontunit": { "type": "string", "options": ["em", "px", "pt"], "value": "px", "hidelabel": true, "widget": "icons-radio", "show": !isNativeMobileApplicationType },
    "textdecoration": { "type": "string", "options": ["underline"], "hidelabel": true, "widget": "toggle-checkbox" },
    "fontstyle": { "type": "string", "options": ["italic"], "widget": "toggle-checkbox" },
    "fontfamily": { "type": "string", "hint": "Arial, Geneva" },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" },
    "position": { "type": "list", "options": ["relative", "sticky"], "parent": "position", "value": "relative", "show": false },
    "zindex": { "type": "list", "options": ["auto", "inherit", "initial"], "widget": "input-select", "value": "1", "pattern": zindexRegex, "show": false, "parent": "position" },
  },
  "wm.containers.native_mobile": {
    ...nativeMobileBackgroundProps,
    "showindevice": { "type": "select-all", "options": showInDeviceOptionsForMobile, "value": "all", "displaytype": 'block' },
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
  },
  'wm.containers.borderstyle': {
    "borderwidth": { "type": "string", "widget": "box-model" },
    "borderstyle": { "type": "string", "options": ["dashed", "dotted", "none", "solid"], "widget": "border-style" },
    "bordercolor": { "type": "string", "widget": "color" }
  },
  'wm.containers.layout': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" },
  },
  'wm.containers.autolayout.web_prism': {
    "position": { "type": "list", "options": ["relative", "sticky"], "parent": "position", "value": "relative" },
    "zindex": { "type": "list", "options": ["auto", "inherit", "initial"], "widget": "input-select", "value": "1", "pattern": zindexRegex, "show": false, "parent": "position" },
    "clipcontent": { "type": "boolean", "parent": "layout", "value": false, "show": false },
    "overflow": { "type": "list", "options": ["No scrolling", "Vertical", "Horizontal", "Both directions"], "parent": "layout", "value": "No scrolling", "show": false }
  },
  'wm.containers.autolayout.prism': {
    "direction": {
      "type": "icons-radio",
      "options": ["row", "column"],
      "showWrap": true,
      "parent": "layout",
      "wrapOn": "row",
      "icons": ["autolayout-direction-row", "autolayout-direction-column"],
      "showLabels": false,
      "value": ""
    },
    "wrap": {
      "type": "icons-radio",
      "wrapIcon": "row-wrap",
      "value": false,
      "show": false
    },
    "alignment": {
      "type": "string",
      "icons": ['top-left', 'top-center', 'top-right',
        'middle-left', 'middle-center', 'middle-right',
        'bottom-left', 'bottom-center', 'bottom-right'],
      "widget": "icon-selector-grid",
      "value": "",
      'displaytype': 'inlineblock'
    },
    "gap": { "type": "list", "options": ["auto"], "widget": "spacing-list", "parent": "layout", "value": "", 'displaytype': 'inlineblock'},
    "columngap": { "type": "list", "options": ["auto"], "widget": "spacing-list", "parent": "layout", "value": "", 'displaytype': 'inlineblock', 'show': false},
    "width": { "type": "list", "options": ["hug", "fill"], "widget": "input-select", 'displaytype': 'inlineblock' },
    "height": { "type": "list", "options": ["hug", "fill"], "widget": "input-select", 'displaytype': 'inlineblock'  },
    "padding": { "type": "string", "widget": "spacing-control", "parent": "layout" },
  },

  'wm.containers.autolayout.non_prism': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" },
  },

  'wm.containers.lazy': {
    "loadmode": { "type": "list", "options": ["", "after-select", "after-delay"], "value": "" },
    "loaddelay": { "type": "number", "min": "10", "value": "10" },
    "onReady": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  'wm.scrollablecontainer': {
    "smoothscroll": { "type": "boolean", "value": true, "show": false, "bindable": "in-bound" }
  },

  'wm.layouts.header': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "hint": { "type": "string", "bindable": "in-bound" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound" },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" }
  },
  'wm.layouts.list': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-out-bound" },
    "layout": { "type": "list", "options": ["inline", "vertical"], "value": "vertical" },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'block' },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["list-inline", "list-group"] },
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "overflow": { "type": "list", "options": ["visible", "hidden", "scroll", "auto", "initial", "inherit"], "parent": "displaystyle" }
  },
  'wm.layouts.breadcrumb': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-out-bound" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "itemid": { "type": "string", "widget": "list", "datasetfilter": "terminals", "bindable": "in-bound", "bindonly": "expression", "show": false, "showondataset": true },
    "itemaction": { "show": false },
    "userrole": { "show": false },
    "onBeforenavigate": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  'wm.layouts.nav': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-out-bound" },
    "layout": { "type": "list", "options": ["", "stacked", "justified"] },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "type": { "type": "list", "options": ["pills", "tabs"] },
    "itembadge": { "type": "list", "options": [""], "datasetfilter": "terminals", "show": false, "showondataset": true },
    "addchild": { "hidelabel": true, "options": [{ 'label': 'Anchor', 'widgettype': 'wm-anchor', 'defaults': { 'wm-anchor': { 'iconclass': 'wi wi-file', 'margin': '' } } }, { 'label': 'Menu', 'widgettype': 'wm-menu', 'defaults': { 'wm-menu': { 'iconclass': 'wi wi-file', 'type': 'anchor' } } }, { 'label': 'Popover', 'widgettype': 'wm-popover', 'defaults': { 'wm-popover': { 'iconclass': 'wi wi-file', 'margin': '' } } }, { 'label': 'Button', 'widgettype': 'wm-button', 'defaults': { 'wm-button': { 'iconclass': 'wi wi-file', 'margin': '' } } }], "widget": "add-widget" },
    "selecteditem": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "getTypeFrom": "dataset" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["app-header-actions"] },
    "orderby": { "type": "list", "widget": "order-by", "datasetfilter": "terminals", "show": false, "showondataset": true },
    "overflow": { "type": "list", "options": ["visible", "hidden", "scroll", "auto", "initial", "inherit"], "parent": "displaystyle" },
    "margin": { "type": "string", "widget": "box-model" },
    "autoclose": { "type": "list", "show": false, "widget": "select-by-object", "value": "outsideClick", "options": [{ "label": "Outside Click", "value": "outsideClick" }, { "label": "Always", "value": "always" }, { "label": "Disabled", "value": "disabled" }], "showondataset": true },
    "autoopen": { "type": "list", "show": false, "widget": "select-by-object", "value": "never", "options": [{ "label": "Never", "value": "never" }, { "label": "Always", "value": "always" }, { "label": "Active Page", "value": "activepage" }], "showondataset": true },
    "showonhover": {"type": "boolean", "value": false, "bindable": "in-out-bound"},
    "itemhint": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals", "show": false, "showondataset": true },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" }
  },
  'wm.layouts.nav.native_mobile': {
    "userrole": { "show": false, "hidelabel": true },
    "itemaction": { "show": false, "hidelabel": true },
    "isactive": { "show": false, "hidelabel": true },
    "layout": { "show": false, "hidelabel": true },
    "type": { "show": false, "hidelabel": true },
    "autoopen": { "show": false, "hidelabel": true },
    "autoclose": { "show": false, "hidelabel": true },
    "orderby": { "show": false },
    "addchild": {
      "hidelabel": true, "options": [
        { 'label': 'Anchor', 'widgettype': 'wm-anchor', 'defaults': { 'wm-anchor': { 'iconclass': 'wi wi-file', 'margin': '' } } },
        //{'label': 'Menu', 'widgettype': 'wm-menu', 'defaults': {'wm-menu': {'iconclass': 'wi wi-file', 'type': 'anchor'} } },
        //{'label': 'Popover', 'widgettype': 'wm-popover', 'defaults': {'wm-popover': {'iconclass': 'wi wi-file', 'margin': ''} } },
        { 'label': 'Button', 'widgettype': 'wm-button', 'defaults': { 'wm-button': { 'iconclass': 'wi wi-file', 'margin': '' } } }],
      "widget": "add-widget"
    },
    "itemhint": { "show": false },
    "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint " },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "button" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  'wm.layouts.navbar': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-out-bound" },
    "menuiconclass": { "type": "string", "widget": "select-icon", "pattern": classRegex, "value": "wi wi-more-vert" },
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "imgsrc": { "type": "string", "bindable": "in-bound" },
    "homelink": { "type": "string", "bindable": "in-bound" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["navbar-inverse"] }
  },
  "wm.layouts.navbar.native_mobile": nativeMobileBackgroundProps,
  'wm.layouts.mobile.navbar': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-out-bound" },
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "leftnavpaneliconclass": { "type": "string", "widget": "select-icon", "pattern": classRegex, "value": "wm-sl-l sl-hamburger-menu" },
    "backbutton": { "type": "boolean", "value": true },
    "backbuttoniconclass": { "type": "string", "widget": "select-icon", "pattern": classRegex, "value": "wi wi-back" },
    "backbuttonlabel": { "type": "string" },
    "searchbutton": { "type": "boolean", "value": false },
    "searchbuttoniconclass": { "type": "string", "widget": "select-icon", "pattern": classRegex, "value": "wm-sl-l sl-search", "show": false },
    "searchbuttonlabel": { "type": "string", "show": false },
    "searchplaceholder": { "type": "string", "value": "Search", "show": false },
    "onSearch": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBackbtnclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "imgsrc": { "type": "string", "bindable": "in-bound" },
    "datavalue": { "type": "string, object", "widget": "string", "bindable": "in-out-bound", "getTypeFrom": "dataset" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "searchkey": { "type": "string", "widget": "select-all", "datasetfilter": "terminals" },
    "displaylabel": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" },
    "displayimagesrc": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" },
    "datafield": { "type": "list", "options": ["All Fields"], "value": "All Fields", "datasetfilter": "terminals", "allfields": true },
    "defaultview": { "type": "select-by-object", "options": [{ "label": "action-view", "value": "actionview" }, { "label": "search-view", "value": "searchview" }], "value": "actionview", "displayfield": "label", "datafield": "value" },
    "query": { "type": "string", "bindable": "in-out-bound", "value": "" },
    "addchild": { "label": "Add", "hidelabel": true, "options": [{ "label": "Anchor", "widgettype": "wm-anchor", "defaults": { "iconclass": "wi wi-gear", "caption": "", "margin": "" } }, { "label": "Menu", "widgettype": "wm-menu", "defaults": { "iconclass": "wi wi-more-vert", "type": "anchor", "caption": "" } }, { "label": "Popover", "widgettype": "wm-popover", "defaults": { "iconclass": "wi wi-bell", "caption": "" } }, { "label": "Button", "widgettype": "wm-button", "defaults": { "iconclass": "", "class": "navbar-btn btn-primary", "caption": "Action" } }], "widget": "add-widget" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "debouncetime": { "type": "number", "value": "250", "show": true },
    "matchmode": { "type": "select-by-object", "options": matchModes, "value": "startignorecase", "show": false }
  },
  "wm.layouts.mobile.navbar.native_mobile": {
    "addchild": {
      "label": "Add", "hidelabel": true,
      "options": [{
        "label": "Anchor",
        "widgettype": "wm-anchor",
        "defaults": { "iconclass": "wi wi-gear", "class": "navbarAnchorItem", "caption": "", "margin": "" }
      }, {
        "label": "Menu",
        "widgettype": "wm-menu",
        "defaults": { "iconclass": "wi wi-more-vert", "class": "navbarMenu", "type": "anchor", "caption": "" }
      }, {
        "label": "Popover",
        "widgettype": "wm-popover",
        "defaults": { "iconclass": "wi wi-bell", "class": "navbarPopover", "caption": "" }
      }, {
        "label": "Button",
        "widgettype": "wm-button",
        "defaults": { "iconclass": "", "class": "btn-primary navbar-btn navbarButton", "caption": "Action" }
      }], "widget": "add-widget"
    },
    "defaultview": { "show": false },
    "searchbutton": { "show": false },
    "onSearch": { "show": false },
    "datavalue": { "show": false },
    "dataset": { "show": false },
    "searchkey": { "show": false },
    "displaylabel": { "show": false },
    "displayimagesrc": { "show": false },
    "datafield": { "show": false },
    "query": { "show": false },
    ...nativeMobileBackgroundProps
  },
  'wm.layouts.listtemplate': {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 }
  },
  'wm.layouts.listactiontemplate': {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "position": { "type": "string", "show": true, "disabled": true },
    "addchild": { "hidelabel": true, "options": [{ "labelKey": "LABEL_ADD_BUTTON", "label": "Add Button", "widgettype": "wm-button", "defaults": { "margin": "" } }], "widget": "add-widget" },
    "enablefullswipe": { "type": "boolean", "value": false }
  },
  'wm.layouts.mediatemplate': {
    "width": { "type": "string", "pattern": dimensionRegex, "value": "100pt" },
    "height": { "type": "string", "pattern": dimensionRegex, "value": "100pt" }
  },
  'wm.layouts.listitem': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["list-group-item", "list-group-item-success", "list-group-item-info", "list-group-item-warning", "list-group-item-danger"] }
  },
  'wm.layouts.topnav': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "hint": { "type": "string", "bindable": "in-bound" },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" }
  },
  'wm.layouts.leftpanel': {
    "columnwidth": { "type": "list", "options": columnWidths, "value": "2" },
    "xscolumnwidth": { "type": "list", "options": columnWidths, "value": "10", "show": false },
    "animation": { "type": "list", "options": ["slide-in", "slide-over"], "value": "slide-in" },
    "hint": { "type": "string", "bindable": "in-bound" },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound" },
    "navtype": {"type": "list", "options": ["drawer", "rail"], "value": "drawer"},
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "navheight": {"type": "list", "options": ["clipped", "full"], "value": "clipped"},
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" }
  },

  'wm.layouts.leftpanel.tab': {
    "columnwidth": { "type": "list", "options": columnWidths, "value": "3" },
    "xscolumnwidth": { "type": "list", "options": columnWidths, "value": "10", "show": false },
    "hint": { "type": "string", "bindable": "in-bound" }
  },
  'wm.layouts.leftpanel.mobile': {
    "columnwidth": { "type": "list", "options": columnWidths, "value": "3", "show": false },
    "xscolumnwidth": { "type": "list", "options": columnWidths, "value": "10", "show": true },
    "gestures": { "type": "string", "value": "on", "bindable": "in-bound" },
    "hint": { "type": "string", "bindable": "in-bound" }
  },
  'wm.layouts.rightpanel': {
    "columnwidth": { "type": "list", "options": columnWidths, "value": "2" },
    "hint": { "type": "string", "bindable": "in-bound" },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound" },
    "navtype": {"type": "list", "options": ["drawer", "rail"], "value": "drawer"},
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" },
  },
  'wm.layouts.content': {
    "height": { "type": "string", "pattern": dimensionRegex }
  },
  'wm.layouts.panel': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": 'Title Icon Class' },
    "iconurl": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconwidth": { "type": "string", "pattern": dimensionRegex },
    "iconheight": { "type": "string", "pattern": dimensionRegex },
    "iconmargin": { "type": "string", "pattern": dimensionRegex },
    "collapsible": { "type": "boolean" },
    "enablefullscreen": { "type": "boolean" },
    "expanded": { "type": "boolean", "value": true },
    "closable": { "type": "boolean" },
    "helptext": { "type": "string", "bindable": "in-out-bound", "widget": "textarea", "showPrettyExprInDesigner": true },
    "actions": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "badgevalue": { "type": "string, number", "widget": "string", "bindable": "in-out-bound", "showPrettyExprInDesigner": true },
    "badgetype": { "type": "string", "widget": "list", "options": ["default", "primary", "success", "info", "warning", "danger"], "value": "default", "bindable": "in-out-bound" },
    "margin": { "type": "string", "widget": "box-model" },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound", "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    /*Events*/
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseout": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseover": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onClose": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onExpand": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onCollapse": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onFullscreen": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onExitfullscreen": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onActionsclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "animation": { "type": "list", "options": animationOptions },
    "hint": { "type": "string", "bindable": "in-bound" }
  },
  "wm.layouts.panel.native_mobile": {
    "actions": { "show": false },
    "enablefullscreen": { "show": false },
    "closable": { "show": false },
    "helptext": { "show": false },
    "onClose": { "show": false },
    "onFullscreen": { "show": false },
    "onExitfullscreen": { "show": false },
    "onActionsclick": { "show": false },
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "onSwipeup": { "show": false },
    "onSwipedown": { "show": false },
    "onSwipeleft": { "show": false },
    "onSwiperight": { "show": false },
    "onPinchin": { "show": false },
    "onPinchout": { "show": false },
    "skeletonanimationresource": {"type": "string", "bindable": "in-out-bound"},
    "skeletonanimationspeed": {"type": 'number', "value": 1},
    "showskeletonchildren": { "type": "boolean", "value": true},
    "expandediconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Expanded Icon Class", "value": "wi wi-chevron-up" },
    "collapsediconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Collapsed Icon Class",  "value": "wi wi-chevron-down" }
  },
  'wm.layouts.panel.defaults': {
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["panel-default", "panel-primary", "panel-success", "panel-info", "panel-warning", "panel-danger"] }
  },
  'wm.layouts.card': {
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "iconurl": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "margin": { "type": "string", "widget": "box-model" },
    "picturesource": { "type": "string", "value": "", "bindable": "in-out-bound" },
    "picturetitle": { "type": "string", "bindable": "in-bound" },
    "imageheight": { "type": "string", "value": "200px" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "actions": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    /*Events*/
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseout": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseover": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "animation": { "type": "list", "options": animationOptions },
    "class": { "type": "string", "pattern": classRegex }
  },
  'wm.layouts.card.native_mobile': {
    "picturetitle": { "show": false },
    "showskeletonchildren": { "type": "boolean", "value": true},
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
  },
  'wm.layouts.cardcontent': {
    "width": { "type": "string", "pattern": dimensionRegex, 'show': false }
  },
  'wm.layouts.cardactions': {
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" }
  },
  'wm.layouts.cardfooter': {
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" }
  },
  'wm.layouts.container': {
    "margin": { "type": "string", "widget": "box-model" },
    "smoothscroll": { "type": "boolean", "value": false, "show": false, "bindable": "in-bound" },
    "borderwidth": { "type": "string", "widget": "box-model" },
    "borderstyle": { "type": "string", "options": ["dashed", "dotted", "none", "solid"], "widget": "border-style" },
    "bordercolor": { "type": "string", "widget": "color" },
    "opacity": { "type": "string", "widget": "slider" },
    "cursor": { "type": "list", "options": ["crosshair", "default", "e-resize", "help", "move", "n-resize", "ne-resize", "nw-resize", "pointer", "progress", "s-resize", "se-resize", "sw-resize", "text", "wait", "w-resize"] },
    "zindex": { "type": "string", "pattern": zindexRegex, "parent": "displaystyle" },
    "visibility": { "type": "list", "options": visibilityOptions },
    "display": { "type": "list", "options": displayOptions },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound", "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true}},
    /*Events*/
    "onClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDblclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onTap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDoubletap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onLongtap": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "onTouchstart": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "onTouchend": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseout": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseover": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "animation": { "type": "list", "options": animationOptions },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["well", "alert", "alert-success", "alert-info", "alert-warning", "alert-danger", "bordered"] },
    "overflow": { "type": "list", "options": ["visible", "hidden", "scroll", "auto", "initial", "inherit"], "parent": "displaystyle" }
  },
  "wm.layouts.container.native_mobile": {
    "sticky": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "onSwipeup": { "show": false },
    "onSwipedown": { "show": false },
    "onSwipeleft": { "show": false },
    "onSwiperight": { "show": false },
    "onPinchin": { "show": false },
    "onPinchout": { "show": false },
    "skeletonanimationresource": {"type": "string", "bindable": "in-out-bound"},
    "skeletonanimationspeed": {"type": 'number', "value": 1},
    "showskeletonchildren": { "type": "boolean", "value": true}
  },
  'wm.layouts.tile': {
    "margin": { "type": "string", "widget": "box-model" },
    /*Events*/
    "onClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDblclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onTap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDoubletap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onLongtap": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "onTouchstart": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "onTouchend": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseout": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onMouseover": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "animation": { "type": "list", "options": animationOptions },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["card", "well", "bg-primary", "bg-success", "bg-info", "bg-warning", "bg-danger"] }
  },
  "wm.layouts.tile.native_mobile": {
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "onSwipeup": { "show": false },
    "onSwipedown": { "show": false },
    "onSwipeleft": { "show": false },
    "onSwiperight": { "show": false },
    "onPinchin": { "show": false },
    "onPinchout": { "show": false },
    "showskeletonchildren": { "type": "boolean", "value": true},
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
  },
  'wm.layouts.footer': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "hint": { "type": "string", "bindable": "in-bound" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["card-footer"] },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" }
  },
  'wm.layouts.linearlayout': {
    // "insert": { "type": "toolbar", "actions": [{ 'action': 'addrow', 'label': 'LABEL_PROPERTY_ADDROW', 'icon': 'wms wms-add-row' }] },
    "spacing": { "type": "number", "widget": "slider", "min": 0, "max": 40, "value": 0, "step": 4 },
    "margin": { "type": "string", "widget": "box-model", "show": false },
    "direction": {
      "type": "icons-radio",
      "parent": "behavior",
      "options": ["row", "row-reverse", "column", "column-reverse"],
      "icons": ["direction-row", "direction-row-reverse", "direction-column", "direction-column-reverse"],
      "showLabels": false,
      "value": "row"
    },
    "wm.layouts.linearlayout.native_mobile": {
      "showskeletonchildren": { "type": "boolean", "value": true},
    },
    "horizontalalign": {
      "type": "icons-radio",
      "options": ["left", "center", "right"],
      "icons": ["align-content-left", "align-content-middle", "align-content-right"],
      "showLabels": false,
      "widget": null,
      "value": "left"
    },
    "verticalalign": {
      "type": "icons-radio",
      "options": ["top", "center", "bottom"],
      "icons": ["align-content-top", "align-content-center", "align-content-bottom"],
      "showLabels": false,
      "value": "top"
    },
    "insert": { "type": "toolbar", "actions": [{ 'action': 'additem', 'label': 'LABEL_PROPERTY_ADDROW', 'icon': 'wms wms-add-row' }] }
  },
  'wm.layouts.linearlayoutitem': {
    "flexgrow": { "type": "number", "widget": "slider", "min": 0, "max": 12, "value": 0, "step": 1 },
    "insert": { "type": "toolbar", "actions": [{ 'action': 'additemafter', 'label': 'LABEL_PROPERTY_ADDROW', 'icon': 'wms wms-add-row' }] }
  },
  'wm.layouts.layoutgrid': {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "value": "condensed", "options": ["condensed", "standard", "bordered"] },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "deferload": { "type": "boolean", "value": false, "show": false },
    "insert": { "type": "toolbar", "actions": [{ 'action': 'addrow', 'label': 'LABEL_PROPERTY_ADDROW', 'icon': 'wms wms-add-row' }] },
    "columns": { "type": "list", "options": ["1", "2", "3", "4", "6", "12"] },
    "backgroundcolor": { "type": "string", "widget": "color", "show": false },
    "backgroundgradient": { "type": "string", "show": false },
    "backgroundimage": { "type": "string", "bindable": "in-bound", "show": false },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"], "show": false },
    "backgroundsize": { "type": "string", "hint": "width, height", "show": false },
    "backgroundposition": { "type": "string", "hint": "top, left", "show": false },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"], "show": false },
    "padding": { "type": "string", "widget": "box-model", "show": false },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" },
  },
  "wm.layouts.layoutgrid.native_mobile": { ...nativeMobileBackgroundProps, ...nativeMobileClassListPickerProps},
  'wm.layouts.gridcolumn': {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" },
    "borderwidth": { "type": "string", "widget": "box-model", "show": false },
    "borderstyle": { "type": "string", "options": ["dashed", "dotted", "none", "solid"], "widget": "border-style", "show": false },
    "bordercolor": { "type": "string", "widget": "color", "show": false },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "backgroundcolor": { "type": "string", "widget": "color", "show": false },
    "backgroundgradient": { "type": "string", "show": false },
    "backgroundimage": { "type": "string", "bindable": "in-bound", "show": false },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"], "show": false },
    "backgroundsize": { "type": "string", "hint": "width, height", "show": false },
    "backgroundposition": { "type": "string", "hint": "top, left", "show": false },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"], "show": false },
    "height": { "type": "string", "pattern": dimensionRegex },
    "columnwidth": { "type": "list", "options": columnWidths },
    "insert": { "type": "toolbar", "actions": [{ 'action': 'addcolumnleft', 'label': 'LABEL_PROPERTY_ADDCOLUMNLEFT', 'icon': 'wms wms-add-column-left' }, { 'action': 'addcolumnright', 'label': 'LABEL_PROPERTY_ADDCOLUMNRIGHT', 'icon': 'wms wms-add-column-right' }] },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["visible-xs-block", "visible-sm-block", "visible-md-block", "visible-lg-block", "hidden-xs", "hidden-sm", "hidden-md", "hidden-lg", "bordered", "bordered-left", "bordered-right", "bordered-top", "bordered-bottom"] }
  },
  "wm.layouts.gridcolumn.native_mobile": {"showskeletonchildren": { "type": "boolean", "value": true}, ...nativeMobileBackgroundProps, ...nativeMobileClassListPickerProps},
  'wm.layouts.gridcolumn.mobile': {
    "columnwidth": { "type": "list", "options": columnWidths, show: false },
    "xscolumnwidth": { "type": "list", "options": columnWidths, show: true },
    "showindevice": { "type": "select-all", "options": showInDeviceOptionsForMobile, "value": "all", "displaytype": 'block', show: true }
  },
  'wm.layouts.gridcolumn.tab': {
    "columnwidth": { "type": "list", "options": columnWidths, show: true },
    "xscolumnwidth": { "type": "list", "options": columnWidths, show: false },
    "showindevice": { "type": "select-all", "options": showInDeviceOptionsForMobile, "value": "all", "displaytype": 'block', show: true }
  },
  'wm.layouts.gridrow': {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["bordered-top", "bordered-bottom"] },
    "borderwidth": { "type": "string", "widget": "box-model", "show": false },
    "borderstyle": { "type": "string", "options": ["dashed", "dotted", "none", "solid"], "widget": "border-style", "show": false },
    "bordercolor": { "type": "string", "widget": "color", "show": false },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "backgroundcolor": { "type": "string", "widget": "color", "show": false },
    "height": { "type": "string", "pattern": dimensionRegex },
    "overflow": { "type": "list", "options": ["visible", "hidden", "scroll", "auto", "initial", "inherit"], "parent": "displaystyle" },
    "insert": { "type": "toolbar", "actions": [{ 'action': 'addrowbelow', 'label': 'LABEL_PROPERTY_ADDROWBELOW', 'icon': 'wms wms-add-row-below' }, { 'action': 'addrowabove', 'label': 'LABEL_PROPERTY_ADDROWABOVE', 'icon': 'wms wms-add-row-above' }, { 'action': 'addcolumn', 'label': 'LABEL_PROPERTY_ADDCOLUMN', 'icon': 'wms wms-add-column' }] }
  },
  "wm.layouts.gridrow.native_mobile": nativeMobileClassListPickerProps,
  'wm.layouts.column': {
    "columnwidth": { "type": "list", "options": columnWidths }
  },
  'wm.layouts.pagecontent': {
    "columnwidth": { "type": "list", "options": columnWidths },
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "variant": { "type": "list", "options": [], "value": "", "widget": "variant-typeahead" },
  },
  'wm.layouts.pagecontent.mobile': {
    "onPulltorefresh": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  'wm.layouts.pagecontent.native_mobile':{
    "skeletonanimationresource": {"type": "string", "bindable": "in-out-bound"},
    "skeletonanimationspeed": {"type": 'number', "value": 1},
    "scrollable": {"type": "boolean", "value": true}
  },
  'wm.layouts.row': {
    "show": { "type": "boolean", "value": true }
  },
  'wm.layouts.view': {
    "show": { "type": "boolean", "value": true, "bindable": "in-out-bound" },
    "deferload": { "type": "boolean", "value": false, "show": false },
    "viewgroup": { "type": "string", "value": "default" },
    "animation": { "type": "list", "options": animationOptions }
  },
  'wm.layouts.form': {
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "novalidate": { "type": "boolean", "show": false },
    "validationtype": { "type": "select-by-object", "options": [{ "label": "Default", "value": "default" }, { "label": "HTML", "value": "html" }, { "label": "No Validations", "value": "none" }], "value": "default", "displayfield": "label", "datafield": "value", "showindesigner": true },
    "autocomplete": { "type": "boolean", "value": false, "showindesigner": true },
    "action": { "type": "string", "bindable": "in-bound", "showindesigner": true },
    "target": { "type": "list", "options": ["_blank", "_parent", "_self", "_top"], "value": "", "widget": "data-list", "showindesigner": true },
    "method": { "type": "list", "options": ["post", "put", "delete"], "showindesigner": true },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "dataset": { "type": "array, object", "widget": "string", "bindable": "in-bound" },
    "captionsize": { "type": "string", "show": false },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "formdata": { "type": "object", "bindable": "in-bound", "widget": "string", "getTypeFrom": "dataset" },
    "dataoutput": { "type": "object", "bindable": "out-bound", "widget": "string", "getTypeFrom": "dataset" },
    "messagelayout": { "type": "list", "options": ["Inline", "Toaster"], "value": "Inline", "showindesigner": true },
    "postmessage": { "type": "string", "value": "Data posted successfully", "bindable": "in-bound", "showindesigner": true },
    "errormessage": { "type": "string", "value": "An error occured. Please try again!", "bindable": "in-bound", "showindesigner": true },
    "captionalign": { "type": "list", "options": ["left", "center", "right"], "value": "left", "showindesigner": true, "widget": "icons-align" },
    "enctype": { "type": "list", "options": ["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"], "showindesigner": true },
    "metadata": { "type": "array, object", "bindable": "in-bound", "widget": "string", "show": false },
    "advancedsettings": { "type": "button", "hidelabel": true, "iconclass": "web-service" },
    "captionposition": { "type": "list", "options": ["left", "right", "top", "floating"], "value": "left", "showindesigner": true, "widget": "toggle-radio", "prefix": "position-" },
    "captionwidth": { "type": "string", "widget": "device-config", "value": "xs-12 sm-3 md-3 lg-3", "showindesigner": true, "widthHeader": "Column Width", "deviceHeader": "Device", "deviceSizes": columnWidths },

    "onResult": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onError": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSuccess": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSubmit": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforerender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onBeforesubmit": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "tabindex": { "type": "number", "value": "0" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "margin": { "type": "string", "widget": "box-model" },
    "formWidgets": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "isWidgetMap": true },
    "validationMessages": { "type": "object", "bindable": "out-bound", "isList": true, "widget": "string" },
    "readonly":{ "type": "boolean", "bindable": "in-bound" }
  },
  "wm.layouts.form.native_mobile": {
    "validationtype": { "show": false },
    "method": { "show": false },
    "action": { "show": false },
    "enctype": { "show": false,"showindesigner":true },
    "target": { "show": false },
    "captionalign": { "show": false },
    "captionposition": {"type": "list", "options": ["top", "floating"], "value": "top", "showindesigner": true, "widget": "toggle-radio", "prefix": "position-"},
    "captionwidth": { "show": false },
    "autocomplete": { "show": false },
    "onSwipeup": { "show": false },
    "onSwipedown": { "show": false },
    "onSwipeleft": { "show": false },
    "onSwiperight": { "show": false },
    "onPinchin": { "show": false },
    "onPinchout": { "show": false },
    "readonly":{ "show": false },
    "submitondone": {"type": "boolean", "value": false, "bindable": 'in-bound'},
    "layoutposition": {"type": "list","options": ["vertical", "horizontal"], "value": "vertical", "bindable": 'in-bound'},
    ...nativeMobileBackgroundProps},
  'wm.layouts.form.mobile': {
    "captionwidth": { "type": "string", "widget": "device-config", "value": "xs-4 sm-4 md-4 lg-4", "showindesigner": true, "widthHeader": "Column Width", "deviceHeader": "Device", "deviceSizes": columnWidths }
  },
  'wm.layouts.form.prism': {
    "itemsperrow": { "type": "string", "widget": "device-config", "widthHeader": "Items per row", "deviceHeader": "Device", "deviceSizes": ['1', '2', '3', '4', '6', '12'], "tableClass": "wm-table-dark" },
  },
  'wm.layouts.login': {
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "onSubmit": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforerender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker" },
    "margin": { "type": "string", "widget": "box-model" }
  },
  'wm.layouts.liveform': {
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "formlayout": { "type": "toggle", "options": { "onLabel": "INLINE", "onValue": "inline", "offLabel": "PAGE", "offValue": "page" }, "value": "inline", "show": false },
    "autocomplete": { "type": "boolean", "value": false, "showindesigner": true },
    "captionsize": { "type": "string", "value": "", "show": false },
    "captionalign": { "type": "string", "options": ["left", "center", "right"], "value": "left", "showindesigner": true, "widget": "icons-align" },
    "captionposition": { "type": "string", "options": ["left", "right", "top", "floating"], "value": "left", "showindesigner": true, "widget": "toggle-radio", "prefix": "position-" },
    "captionwidth": { "type": "string", "widget": "device-config", "value": "xs-12 sm-3 md-3 lg-3", "showindesigner": true, "widthHeader": "Column Width", "deviceHeader": "Device", "deviceSizes": columnWidths },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "advancedsettings": { "type": "button", "hidelabel": true, "iconclass": "web-service" },
    "height": { "type": "string", "pattern": dimensionRegex },
    "rowdata": { "type": "string" },
    "formdata": { "type": "object", "bindable": "in-bound", "widget": "string", "getTypeFrom": "dataset" },
    "dataoutput": { "type": "object", "bindable": "out-bound", "widget": "string", "getTypeFrom": "dataset" },
    "novalidate": { "type": "boolean", "showindesigner": false, "show": false },
    "validationtype": { "type": "select-by-object", "options": [{ "label": "Default", "value": "default" }, { "label": "HTML", "value": "html" }, { "label": "No Validations", "value": "none" }], "value": "default", "displayfield": "label", "datafield": "value", "showindesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "show": false },
    "defaultmode": { "type": "toggle", "options": { "onLabel": "READONLY", "onValue": "View", "offLabel": "EDITABLE", "offValue": "Edit" }, "value": "View", "showindesigner": true },
    "width": { "type": "string", "pattern": dimensionRegex },
    "messagelayout": { "type": "list", "options": ["Inline", "Toaster"], "value": "Toaster", "showindesigner": true },
    "insertmessage": { "type": "string", "value": "Record added successfully", "bindable": "in-bound", "showindesigner": true },
    "updatemessage": { "type": "string", "value": "Record updated successfully", "bindable": "in-bound", "showindesigner": true },
    "deletemessage": { "type": "string", "value": "Record deleted successfully", "bindable": "in-bound", "showindesigner": true },
    "errormessage": { "type": "string", "value": "An error occured. Please try again!", "bindable": "in-bound", "showindesigner": true },
    /*Events*/
    "onBeforeservicecall": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onResult": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onError": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSuccess": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "tabindex": { "type": "number", "value": "0" },
    // property specific to mobile with formlayout page
    "onBackbtnclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundgradient": { "type": "string" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "backgroundrepeat": { "type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"] },
    "backgroundsize": { "type": "string", "hint": "width, height" },
    "backgroundposition": { "type": "string", "hint": "top, left" },
    "backgroundattachment": { "type": "list", "options": ["fixed", "local", "scroll"] },
    "margin": { "type": "string", "widget": "box-model" },
    "formWidgets": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "isWidgetMap": true },
    "validationMessages": { "type": "object", "bindable": "out-bound", "isList": true, "widget": "string" }
  },
  "wm.layouts.liveform.native_mobile":{...nativeMobileBackgroundProps, ...nativeMobileClassListPickerProps},
  'wm.layouts.liveform.mobile': {
    "captionwidth": { "type": "string", "widget": "device-config", "value": "xs-4 sm-4 md-4 lg-4", "showindesigner": true, "widthHeader": "Column Width", "deviceHeader": "Device", "deviceSizes": columnWidths }
  },
  "wm.layouts.segmentedcontrol": {
    "onBeforesegmentchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSegmentchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "width": { "show": false },
    "height": { "type": "string", "pattern": dimensionRegex },
    "tabindex": { "type": "number", "value": "0" },
    "addchild": { "label": "Add", "hidelabel": true, "options": [{ "label": "Segmented Content", "widgettype": "wm-segment-content" }], "widget": "add-widget" }
  },
  "wm.layouts.segmentcontent": {
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex }
  },
  'wm.table': {
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "bindInfo": {evaulateBindings: true, invokeVariable: true} },
    "datasource": { "type": "string", "show": false },
    "pagesize": { "type": "number" },
    "advancedsettings": { "type": "button", "hidelabel": true, "iconclass": "web-service" },
    "gridfirstrowselect": { "type": "boolean", "value": false, "bindable": "in-bound", "showindesigner": true },
    "isrowselectable": {"type":"boolean", "value": false, "bindable": "in-bound","showindesigner": true},
    "allowpagesizechange": {"type":"boolean", "value": false, "bindable": "in-bound", "showindesigner": true },
    "pagesizeoptions" :{"type": "string", "value": "5,10,20,50,100", "widget": "string", "bindable": "in-bound", "showindesigner": true},
    "formposition": { "type": "select-by-object", "options": [{ "label": "Top", "value": "top" }, { "label": "Bottom", "value": "" }], "value": "", "displayfield": "label", "datafield": "value", "showindesigner": true },
    "shownewrow": { "type": "boolean", "show": false, "value": true },
    "confirmdelete": { "type": "string", "value": "Are you sure you want to delete this?", "bindable": "in-bound", "show": true, "showindesigner": true },
    "deleterow": { "type": "boolean", "bindable": "in-bound", "show": false },
    "updaterow": { "type": "boolean", "bindable": "in-bound", "show": false },
    "showheader": { "type": "boolean", "value": true, "bindable": "in-bound", "showindesigner": true },
    "gridsearch": { "type": "boolean", "show": false, "showindesigner": false },
    "rowclass": { "type": "string", "value": "", "showindesigner": true },
    "rowngclass": { "showindesigner": "true", "widget": "conditional-expression" },
    "filtermode": { "type": "select-by-object", "options": [{ "labelkey": "LABEL_NO_FILTER", "value": "" }, { "labelkey": "LABEL_SEARCH", "value": "search" }, { "labelkey": "LABEL_MULTI_COLUMN", "value": "multicolumn" }], "value": "", "displayfield": "label", "datafield": "value", "showindesigner": true },
    "searchlabel": { "type": "string", "value": "Search", "bindable": "in-bound", "show": false, "showindesigner": false, "alignright": true },
    "filteronkeypress": { "type": "boolean", "value": false, "show": false, "showindesigner": false },
    "enablesort": { "type": "boolean", "value": true, "bindable": "in-bound", "showindesigner": true },
    "enablecolumnselection": { "type": "boolean", "value": false, "bindable": "in-bound", "showindesigner": true },
    "showrowindex": { "type": "boolean", "showindesigner": true },
    "multiselect": { "type": "boolean", "value": false, "bindable": "in-bound", "showindesigner": true },
    "multiselecttitle": { "type": "string", "value": "", "bindable": "in-bound", "showindesigner": true },
    "multiselectarialabel": { "type": "string", "value": "", "bindable": "in-bound", "showindesigner": true},
    "radioselect": { "type": "boolean", "value": false, "bindable": "in-bound", "showindesigner": true },
    "headerselectall":{ "type": "boolean","value": false,"show": false, "showindesigner": true },
    "radioselecttitle": { "type": "string", "value": "", "bindable": "in-bound", "showindesigner": true },    
    "radioselectarialabel": { "type": "string", "value": "", "bindable": "in-bound", "showindesigner": true },
    "insertrow": { "type": "boolean", "bindable": "in-bound", "show": false },
    "editmode": { "type": "string", "value": "", "show": false },
    "showrecordcount": { "type": "boolean", "show": false, "bindable": "in-bound", "showindesigner": true },
    "showviewlessbutton": { "type": "boolean", "show": false, "showindesigner": true },
    "statehandler": { "type": "list", "options": ["URL", "localStorage", "sessionStorage", "none"], "value": "none" },
    "navigation": { "type": "select-by-object", "options": [{ 'value': 'Basic', 'label': 'Basic' }, { 'value': 'Pager', 'label': 'Pager' }, { 'value': 'Classic', 'label': 'Classic' }, { 'value': 'Scroll', 'label': 'Infinite Scroll' }, { 'value': 'None', 'label': 'None' }, { 'value': 'On-Demand', 'label': 'On Demand' }], "value": "Basic", "showindesigner": true },
    "navigationalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "value": "left", "showindesigner": true },
    "filternullrecords": { "type": "boolean", "value": true },
    "ondemandmessage": { "type": "string", "bindable": "in-bound", "showindesigner": true, "value": "Load More" },
    "viewlessmessage": { "type": "string", "bindable": "in-bound", "showindesigner": true, "value": "View Less" },
    "nodatamessage": { "type": "string", "value": "No data found.", "bindable": "in-bound", "showindesigner": true },
    "loadingdatamsg": { "type": "string", "value": "Loading...", "bindable": "in-bound", "showindesigner": true },
    "loadingicon": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "value": "fa fa-circle-o-notch fa-spin", "pattern": classRegex },
    "deletemessage": { "type": "string", "value": "Record deleted successfully", "bindable": "in-bound", "show": true, "showindesigner": true },
    "errormessage": { "type": "string", "value": "", "bindable": "in-bound", "showindesigner": true },
    "insertmessage": { "type": "string", "value": "Record added successfully", "bindable": "in-bound", "showindesigner": true },
    "updatemessage": { "type": "string", "value": "Record updated successfully", "bindable": "in-bound", "showindesigner": true },
    "deleteoktext": { "type": "string", "value": "bind:appLocale.LABEL_OK", "bindable": "in-bound", "showindesigner": true },
    "deletecanceltext": { "type": "string", "value": "bind:appLocale.LABEL_CANCEL", "bindable": "in-bound", "showindesigner": true },
    "selecteditem": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "getTypeFrom": "dataset", "getIsListFrom": "expr:multiselect" },
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "spacing": { "type": "list", "options": ["normal", "condensed"], "value": "normal" },
    "exportformat": { "type": "list", "widget": "select-all", "options": ["EXCEL", "CSV"], "showindesigner": true },
    "exportdatasize": { "type": "number", "value": 100, "showindesigner": true },
    "margin": { "type": "string", "widget": "box-model", "show": false }, //Deprecated margin property for data table
    "currentItem": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "getTypeFrom": "dataset" },

    /* Events */
    "onClick": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onTap": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onRowselect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onRowdeselect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSort": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onHeaderclick": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onShow": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onHide": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforeformrender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onFormrender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onRowdelete": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforerowinsert": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onRowinsert": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforerowupdate": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforerowdelete": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onRowupdate": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onError": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onRowclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onRowdblclick": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onColumnselect": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onColumndeselect": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onSetrecord": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },
    "onDatarender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforedatarender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforeexport": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onBeforefilter": { "type": "event", "show": false, "options": widgetEventOptions, "widget": "eventlist" },

    /* Styles */
    "gridclass": { "type": "string", "value": "table-hover", "pattern": classRegex, "widget": "list-picker", "options": ["table-hover", "table-bordered", "table-striped"] },
    "tabindex": { "type": "number", "value": "0" }

  },
  'wm.table.column': {
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "caption": { "type": "string", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: false} },
    "checkedvalue": { "type": "string" },
    "col-class": { "type": "string" },
    "col-ng-class": { "bindable": "in-bound" },
    "collapsible": { "type": "boolean" },
    "currencypattern": { "type": "string" },
    "dataentrymode": { "type": "string" },
    "datafield": { "type": "string" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "datasource": { "type": "string" },
    "dateformat": { "type": "string" },
    "datepattern": { "type": "string" },
    "defaultvalue": { "type": "string" },
    "disabled": { "type": "boolean" },
    "displayfield": { "type": "string" },
    "displaylabel": { "type": "string" },
    "editdatepattern": { "type": "string" },
    "outputformat": { "type": "string" },
    "edit-widget-type": { "type": "string" },
    "editinputtype": { "type": "string" },
    "exportexpression": { "type": "string" },
    "filterdataset": { "type": "string" },
    "filterdatafield": { "type": "string" },
    "filterdisplayfield": { "type": "string" },
    "filterdisplaylabel": { "type": "string" },
    "filterexpressions": { "type": "string" },
    "filtersearchkey": { "type": "string" },
    "filter-on": { "type": "string" },
    "filteronfilter": { "type": "string" },
    "filterplaceholder": { "type": "string" },
    "filterwidget": { "type": "string" },
    "filterinputtype": { "type": "string" },
    "formatpattern": { "type": "string" },
    "custompipeformat": { "type": "string" },
    "fractionsize": { "type": "string" },
    "groupby": { "type": "string" },
    "generator": { "type": "string" },
    "limit": { "type": "string" },
    "match": { "type": "string" },
    "matchmode": { "type": "string" }
  },
  'wm.livetable': {
    'formlayout': { "type": "list", "options": ["inline", "dialog"], "value": "inline" }
  },
  'wm.fileupload': {
    "multiple": { "type": "boolean", "value": false },
    "contenttype": { "type": "list", "bindable": "in-out-bound", "widget": "list-picker", "options": ["image/*", "audio/*", "video/*", ".txt", ".zip", ".rar", ".js", ".json", ".xls", ".xlsx", ".pdf", ".csv", ".xml", ".doc", ".docx", ".log", ".rtf", ".bmp", ".gif", ".jpe", ".jpg", ".jpeg", ".tif", ".tiff", ".pbm", ".png", ".ico", ".mp3", ".ogg", ".webm", ".wma", ".3gp", ".wav", ".mp4", ".ogg", ".webm", ".wmv", ".mpeg", ".mpg", ".avi"] },
    "fileuploadmessage": { "type": "string", "bindable": "in-out-bound", "value": "Drop your files here or click here to browse" },
    "tabindex": { "type": "number", "value": "0" },
    "selectedFiles": { "type": "array, file", "isList": true, "bindable": "in-out-bound", "show": "false", "getTypeFrom": "expr:getPropertyType('selectedFiles')" },
    "maxfilesize": { "type": "string", "widget": "fileupload-relativepath", "bindable": "in-out-bound", "value": "", "info": "size in MB" },
    "caption": { "type": "string", "value": "Upload", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "disabled": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "value": "wi wi-file-upload", "pattern": classRegex },
    "cleariconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "value": "", "pattern": classRegex },
    "cleariconhint": { "type": "string", "bindable": "in-out-bound", "value": "Clear" },
    "filelistheight": { "type": "string", "pattern": dimensionRegex, "show": false },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["bg-primary", "bg-success", "bg-info", "bg-warning", "bg-danger"] },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    /* ---- events ---- */
    "onBeforeselect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onError": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforedelete": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDelete": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
  },
  'wm.fileupload.mobile': {
    "fileuploadmessage": { "show": false },
    "contenttype": {"type": "list", "bindable": "in-out-bound", "widget" : "list-picker", "options": ["image/*", "audio/*", "video/*", ".txt", ".zip", ".rar", ".js", ".json", ".xls", ".xlsx", ".pdf", ".csv", ".xml", ".doc", ".docx", ".log", ".rtf", ".bmp", ".gif", ".jpe", ".jpg", ".jpeg", ".tif", ".tiff", ".pbm", ".png", ".ico", ".mp3", ".ogg", ".webm", ".wma", ".3gp", ".wav", ".mp4", ".ogg", ".webm", ".wmv", ".mpeg", ".mpg", ".avi"]}
  },
  'wm.fileupload.native_mobile': {
    "multiple": { "show": false },
    "arialabel":{"show":false },
    "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "button" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },

  },
  'wm.youtube': {
    "width": { "value": "800px", "pattern": dimensionRegex },
    "height": { "value": "125px", "pattern": dimensionRegex },
    "uploadpath": { "type": "string" }
  },
  "wm.anchor": {
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex },
    "iconurl": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconwidth": { "type": "string", "pattern": dimensionRegex },
    "iconheight": { "type": "string", "pattern": dimensionRegex },
    "iconmargin": { "type": "string", "pattern": dimensionRegex },
    "iconposition": { "type": "list", "options": ["left", "top", "right"] },
    "caption": { "type": "string", "value": "Link", "bindable": "in-out-bound", "maxlength": 256, "showPrettyExprInDesigner": true, "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "badgevalue": { "type": "string", "bindable": "in-out-bound", "showPrettyExprInDesigner": true },
    "hyperlink": { "type": "string", "bindable": "in-out-bound" },
    "encodeurl": { "type": "boolean", "value": false },
    "target": { "type": "list", "options": ["_blank", "_parent", "_self", "_top"], "value": "_self", "widget": "data-list" },
    "tabindex": { "type": "number", "value": "0" },
    "whitespace": { "type": "list", "options": [" ", "normal", "nowrap", "pre", "pre-line", "pre-wrap"], "value": " " },
    "wordbreak": { "type": "list", "options": ["break-word", "normal"] },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'inline' },
    "animation": { "type": "list", "options": animationOptions },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["h1", "h2", "h3", "h4", "h5", "h6", "btn-primary", "btn-success", "btn-info", "btn-warning", "btn-danger", "btn-lg", "btn-sm", "btn-xs", "btn-link", "text-ellipsis", "text-left", "text-right", "text-center", "text-muted", "text-primary", "text-success", "text-info", "text-warning", "text-danger", "vertical-align-top", "vertical-align-middle", "vertical-align-bottom", "lead", "badge", "app-header-action"] },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "show": false },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.anchor.native_mobile": {
    "target": { "show": false },
    "shortcutkey": { "show": false },
    "onFocus": { "show": false },
    "onBlur": { "show": false },
    "animation": { "type": "list", "options": reactNativeAnimationOptions },
    "arialabel": { "show": false},
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role", "value": "link" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.popover": {
    "contentsource": { "type": "list", "options": ['inline', 'partial'], value: "partial" },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound", "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "inlinecontent": { "type": "string", "widget": "textarea" },
    "hyperlink": { "type": "string", "value": "", "show": false, "bindable": false },
    "target": { "type": "string", "value": "", "show": false },
    "popoverwidth": { "type": "string" },
    "popoverheight": { "type": "string" },
    "popoverarrow": { "type": "boolean", "value": true },
    "popoverautoclose": { "type": "boolean", "value": true, "show": false },
    "interaction": { "type": "select-by-object", "options": [{ 'label': 'Click', 'value': 'click' }, { 'label': 'Hover', 'value': 'hover' }, { 'label': 'Click and Hover', 'value': 'default' }], value: "click" },
    "popoverplacement": { "type": "select-by-object", "options": popoverOptions, "value": "bottom" },
    "title": { "type": "string", "bindable": "in-bound" },
    "onShow": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onHide": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onLoad": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "conditionalclass": { "show": false, "bindable": "in-bound" },
    "contentanimation": { "type": "list", "options": animationOptions },
    "autoclose": { "type": "list", "widget": "select-by-object", "value": "outsideClick", "options": [{ "label": "Outside Click", "value": "outsideClick" }, { "label": "Always", "value": "always" }, { "label": "Disabled", "value": "disabled" }] },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.popover.native_mobile": {
    "popoverwidth": { "show": false },
    "popoverheight": { "show": false },
    "popoverarrow": { "show": false },
    "popoverautoclose": { "show": false },
    "popoverplacement": { "show": false },
    "interaction": { "show": false },
    "contentanimation": { "type": "list", "options": reactNativeAnimationOptions },
    "target": { "show": false },
    "encodeurl": { "show": false },
    "arialabel": { "show": false },
    "hint": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Hint " },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role","value": "button" },
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.prefab": {
    "margin": { "type": "string", "widget": "box-model" },
    "debugurl": { "type": "string", "show": false },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "onLoad": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "displayName": "On Load" },
    "onDestroy": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "displayName": "On Destroy" },
    "animation": { "type": "list", "options": animationOptions },
    "tabindex": { "type": "number", "value": "0" },
    "onOrientationchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true },
    "onResize": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true }
  },
  "wm.prefab.native_mobile": {
    "skeletonanimationresource": {"type": "string", "bindable": "in-out-bound", "show": true},
    "skeletonanimationspeed": {"type": 'number', "value": 1, "show": true},
  },
  "wmx.component": {
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "animation": { "type": "list", "options": animationOptions }
  },
  "wm.custom.widget": {
    "margin": { "type": "string", "widget": "box-model" },
    "debugurl": { "type": "string", "show": false },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "onLoad": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "displayName": "On Load" },
    "onDestroy": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "displayName": "On Destroy" },
    "animation": { "type": "list", "options": animationOptions },
    "tabindex": { "type": "number", "value": "0" },
    "onOrientationchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true },
    "onResize": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true }
  },
  "wm.custom.widget.container": {
    "margin": { "type": "string", "widget": "box-model" },
    "debugurl": { "type": "string", "show": false },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "onLoad": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "displayName": "On Load" },
    "onDestroy": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "displayName": "On Destroy" },
    "animation": { "type": "list", "options": animationOptions },
    "tabindex": { "type": "number", "value": "0" },
    "onOrientationchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true },
    "onResize": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": true },
  },
  "wm.accordion": {
    "addchild": { "hidelabel": true, "options": [{ "labelKey": "LABEL_ADD_ACCORDION_PANE", "label": "Add Accordion Pane", "widgettype": "wm-accordionpane" }], "widget": "add-widget" },
    "closeothers": { "type": "boolean", "value": true },
    "height": { "type": "string", "pattern": dimensionRegex },
    "tabindex": { "type": "number", "value": "0" },
    "type": { "type": "string", "widget": "list", "options": ["static", "dynamic"], "value": "static", "show": true },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "show": false },
    "nodatamessage": { "type": "string", "value": "No data found", "bindable": "in-bound"},
    "defaultpaneindex": { "type": "number", "value": 0, "bindable": "in-bound" },
    "statehandler": { "type": "list", "options": ["URL", "localStorage", "sessionStorage", "none"], "value": "none" },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  "wm.accordion.native_mobile": {
    "statehandler": { "show": false },
    "nodatamessage": { "show": false },
    "showskeletonchildren": { "type": "boolean", "value": true},
    "expandediconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Expanded Icon Class" },
    "collapsediconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Collapsed Icon Class" }
  },
  "wm.accordionpane": {
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound", "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true} },
    "height": { "type": "string", "pattern": dimensionRegex },
    "onExpand": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onCollapse": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "title": { "type": "string", "value": "Title", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "badgevalue": { "type": "string", "bindable": "in-out-bound", "showPrettyExprInDesigner": true },
    "badgetype": { "type": "string", "widget": "list", "options": ["default", "primary", "success", "info", "warning", "danger"], "value": "default", "bindable": "in-out-bound" },
    "tabindex": { "type": "number", "value": "0" },
    "isdefaultpane": { "type": "boolean", "bindable": "in-bound", "show": false }, //Deprecated property
    "padding": { "type": "string", "widget": "box-model", "parent": "displaystyle" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "color": { "type": "string", "widget": "color" },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE }
  },
  "wm.accordionpane.native_mobile": {
    "showskeletonchildren": { "type": "boolean", "value": true},
    "skeletonanimationresource": {"type": "string", "bindable": "in-out-bound"},
    "skeletonanimationspeed": {"type": 'number', "value": 1}
  },
  "wm.richtexteditor": {
    "hint": { "type": "string" },
    "show": { "type": "boolean", "value": true },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "datavalue": { "type": "string", value: "", "bindable": "in-out-bound" },
    "showpreview": { "type": "boolean", "value": false },
    "placeholder": { "type": "string", "bindable": "in-bound" },
    "htmlcontent": { "type": "string", "bindable": "out-bound" },
    "tabindex": { "type": "number", "value": "0" },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforerender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
  },

  "wm.tabs": {
    "addchild": { "hidelabel": true, "options": [{ "labelKey": "LABEL_ADD_TAB_PANE", "label": "Add Tab Pane", "widgettype": "wm-tabpane" }], "widget": "add-widget" },
    "gestures": { "type": "string", "value": "on", "bindable": "in-bound" },
    "tabsposition": { "type": "list", "options": ["left", "top", "right", "bottom"], "value": "top" },
    "taborder": { "type": "list", "widget": "tab-order", "dataset": [] },
    "transition": { "type": "list", "options": ["none", "slide"], "value": "none" },
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "height": { "type": "string", "pattern": dimensionRegex },
    "type": { "type": "string", "widget": "list", "options": ["static", "dynamic"], "value": "static", "show": true },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "show": false },
    "nodatamessage": { "type": "string", "value": "No data found", "bindable": "in-bound" },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align" },
    "defaultpaneindex": { "type": "number", "value": 0, "bindable": "in-bound" },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "statehandler": { "type": "list", "options": ["URL", "localStorage", "sessionStorage", "none"], "value": "none" },
    "enablescroll": {"type": "boolean", "bindable": "in-bound", "value": false},
    "iconposition": { "type": "list", "options": ["left", "top", "right"] },
    "autotabactivation": {"type": "boolean", "bindable": "in-bound", "value": true}
  },
  "wm.tabs.native_mobile": {
        "height": { "type": "string", "pattern": dimensionRegex, "value": "480px" },
        "tabsposition": { "show": false },
        "transition": { "show": false },
        "dataset": { "show": false },
        "nodatamessage": { "show": false },
        "horizontalalign": { "show": false },
        "statehandler": { "show": false },
        "type": { "show": false },
        "showskeletonchildren": { "type": "boolean", "value": true},
        "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
        "autotabactivation": {"show":false},
        "enablegestures": {"type": "boolean", "value": true, "bindable": "in-bound"}
      },
  'wm.tabs.mobile': {
    "transition": { "type": "list", "options": ["none", "slide"], "value": "slide" }
  },

  "wm.tab": {
    "title": { "type": "string", "bindable": "in-bound" }
  },
  "wm.tabpane": {
    "disabled": { "type": "boolean", "bindable": "in-bound" },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onDeselect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onHeaderclick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "title": { "type": "string", "value": "Tab Title", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "paneicon": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "isdefaulttab": { "type": "boolean", "bindable": "in-bound", "show": false }, //Deprecated property
    "tabindex": { "type": "number", "value": "0" },
    "badgevalue": { "type": "string", "bindable": "in-out-bound", "showPrettyExprInDesigner": true },
    "badgetype": { "type": "string", "widget": "list", "options": ["default", "primary", "success", "info", "warning", "danger"], "value": "default", "bindable": "in-out-bound" }
  },
  "wm.tabpane.native_mobile": {
    "disabled": { "show": false },
    "badgevalue": { "show": false },
    "badgetype": { "show": false },
    "onHeaderclick": { "show": false },
    "skeletonanimationresource": {"type": "string", "bindable": "in-out-bound"},
    "skeletonanimationspeed": {"type": 'number', "value": 1}
  },
  "wm.wizard": {
    "addchild": { "hidelabel": true, "options": [{ "labelKey": "LABEL_ADD_STEP", "label": "Add Step", "widgettype": "wm-wizardstep" }], "widget": "add-widget" },
    "nextbtnlabel": { "type": "string", "value": "Next", "bindable": "in-bound" },
    "cancelbtnlabel": { "type": "string", "value": "Cancel", "bindable": "in-bound" },
    "previousbtnlabel": { "type": "string", "value": "Previous", "bindable": "in-bound" },
    "donebtnlabel": { "type": "string", "value": "Done", "bindable": "in-bound" },
    "onDone": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onCancel": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "cancelable": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "enablenext": { "type": "boolean", "value": false, "label": "Enable Next", "bindable": "in-bound" },
    "stepstyle": { "type": "list", "options": ["auto", "justified"], "value": "auto" },
    "actionsalignment": { "type": "list", "options": ["left", "right"], "value": "right" },
    "defaultstep": { "type": "string", "widget": "select-by-object", "value": "none", "bindable": "in-bound" },
    "defaultstepindex": { "type": "number", "value": 0, "bindable": "in-bound", "show": false },
    "type": { "type": "string", "widget": "list", "options": ["static", "dynamic"], "value": "static", "show": !isNativeMobileApplicationType },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "show": false },
    "nodatamessage": { "type": "string", "value": "No data found", "bindable": "in-bound" }
  },
  "wm.wizard.native_mobile": {
    "onChange": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"},
    "stepstyle": { "show": false },
    "horizontalalign": { "show": false },
    "showskeletonchildren": { "type": "boolean", "value": true},
    "donebtniconclass": {"label":"Done Icon","type": "string", "widget": "select-icon", "show": true, "value": "wm-sl-l sl-check", "bindable": "in-out-bound", "pattern": classRegex},
    "showalltitles": { "type": "boolean", "value": false, "bindable": "in-bound" }
  },
  "wm.wizardstep": {
    "title": { "type": "string", "value": "Step Title", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subtitle": { "type": "string", "bindable": "in-bound" },
    "disablenext": { "type": "boolean", "value": false, "show": false },
    "disableprevious": { "type": "boolean", "value": false, "show": false },
    "disabledone": { "type": "boolean", "value": false, "show": false },
    "enabledone": { "type": "boolean", "value": false, "show": false },
    "enableskip": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "iconclass": { "type": "string", "widget": "select-icon", "show": false, "value": "wi wi-person", "bindable": "in-out-bound", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "doneiconclass": { "type": "string", "widget": "select-icon", "show": false, "value": "wi wi-done", "bindable": "in-out-bound", "pattern": classRegex },
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound" },
    "onNext": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onPrev": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onLoad": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSkip": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "loadmode": { "type": "list", "show": false, "value": "after-select" }
  },
  "wm.wizardstep.native_mobile": {
    "onLoad": {"type": "event", "options": widgetEventOptions, "widget": "eventlist"}
  },
  "wm.carousel": {
    "addchild": { "hidelabel": true, "options": [{ "labelKey": "LABEL_ADD_CAROUSEL", "label": "Add Carousel", "widgettype": "wm-carousel-content" }], "widget": "add-widget" },
    "gestures": { "type": "string", "value": "on", "bindable": "in-bound" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "show": false },
    "animationinterval": { "type": "number", "value": "3" },
    "type": { "type": "string", "show": false },
    "currentslide": { "type": "object", "bindable": "in-bound", "widget": "string", "getTypeFrom": "dataset" },
    "animation": { "type": "list", "options": ["auto", "none"], "value": "auto" },
    "controls": { "type": "list", "options": ["navs", "indicators", "both", "none"], "value": "both" },

    "class": { "type": "string", "pattern": classRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'block' },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "currentItem": { "type": "object", "bindable": "in-bound", "show": false, "widget": "string", "getTypeFrom": "dataset" },
    "nodatamessage": { "type": "string", "value": "No data found", "bindable": "in-bound" }
  },
  "wm.carousel.native_mobile":{
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "stopatlast": { "type": "boolean", "value": false, "bindable": "in-bound" },
  },
  "wm.tabbar": {
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "value": "" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "morebuttoniconclass": { "type": "string", "widget": "select-icon", "pattern": classRegex, "value": "wi wi-more-horiz" },
    "morebuttonlabel": { "type": "string", "value": "more" }
  },
  "wm.tabbar.dataProps": {
    "itemlabel": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" },
    "itemlink": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" },
    "itemicon": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" }
  },
  "wm.list": {
    "name": { "type": "string", "pattern": nameRegex, "maxlength": 32 },
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "enablereorder": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE },
    "onSelectionlimitexceed": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onReorder": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "pagesize": { "type": "number" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "selectionlimit": { "type": "number", "bindable": "in-bound" },
    "itemsperrow": { "type": "string", "widget": "device-config", "widthHeader": "Items per row", "deviceHeader": "Device", "deviceSizes": ['1', '2', '3', '4', '6', '12'], "tableClass": "wm-table-dark" },
    "allowpagesizechange": {"type":"boolean", "value": false, "bindable": "in-bound" },
    "pagesizeoptions" :{"type": "string", "value": "5,10,20,50,100", "widget": "string"},
    "selecteditem": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "getTypeFrom": "dataset", "getIsListFrom": "expr:multiselect" },
    "onSetrecord": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onBeforedatarender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onRender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onPaginationchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "itemclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["list-group-item", "media"], "bindable": "in-bound" },
    "listclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["list-group", "list-inline", "media-list"] },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "value": "", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "navigation": { "type": "select-by-object", "options": [{ 'value': 'Basic', 'label': 'Basic' }, { 'value': 'Pager', 'label': 'Pager' }, { 'value': 'Classic', 'label': 'Classic' }, { 'value': 'Scroll', 'label': 'Infinite Scroll' }, { 'value': 'Inline', 'label': 'Horizontal Slider' }, { 'value': 'None', 'label': 'None' }, { 'value': 'On-Demand', 'label': 'On Demand' }], "value": "None" },
    "navigationalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "value": "left" },
    "selectfirstitem": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "tabindex": { "type": "number", "value": "0" },
    "groupby": { "type": "list", "show": true, "widget": "list-typeahead", "datasetfilter": "terminals" },
    "match": { "type": "list-group", "nonGroupOptions": timeNonGroupOptions, "options": timeGroupOptions, "show": false, "value": "word", "datasetfilter": "none" },
    "dateformat": { "type": "list", "options": [], "widget": "date-time-patterns", "show": false },
    "orderby": { "type": "list", "widget": "order-by", "datasetfilter": "terminals" },
    "nodatamessage": { "type": "string", "value": "No data found", "bindable": "in-bound" },
    "loadingdatamsg": { "type": "string", "value": "Loading...", "bindable": "in-bound" },
    "selectedItemWidgets": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "isWidgetMap": true },
    "currentItemWidgets": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "isWidgetMap": true },
    "currentItem": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "getTypeFrom": "dataset" },
    "multiselect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "collapsible": { "type": "boolean", "show": false },
    "showcount": { "type": "boolean", "show": false },
    "disableitem": { "type": "boolean", "bindable": "in-bound", "value": false },
    "ondemandmessage": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true, "value": "Load More" },
    "loadingicon": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "value": "fa fa-circle-o-notch", "pattern": classRegex },
    "paginationclass": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["pagination-sm", "pagination-lg", "btn-default", "btn-primary", "btn-info", "btn-warning", "btn-success", "btn-danger", "btn-inverse", "btn-lg", "btn-sm", "btn-xs", "btn-raised", "btn-fab", "btn-link", "btn-transparent", "jumbotron"] },
    "statehandler": { "type": "list", "options": ["URL", "localStorage", "sessionStorage", "none"], "value": "none" },
    "direction": { "type": "list", "options": ["horizontal", "vertical"], "widget": "icons-radio", "value": "vertical", "parent": "behavior" },
    "hidehorizontalscrollbar": { "type": "boolean", "value": false },
  },
  "wm.list.mobile": {
    "templateview": { "options": [{ 'label': 'ListTemplate', 'value': 'listtemplate', 'widgettype': 'wm-listtemplate', 'isAdded': true }, { 'label': 'LeftActionTemplate', 'value': 'leftactiontemplate', 'widgettype': 'wm-list-action-template', 'defaults': { 'wm-list-action-template': { 'position': 'left' } } }, { 'label': 'RightActionTemplate', 'value': 'rightactiontemplate', 'widgettype': 'wm-list-action-template', 'defaults': { 'wm-list-action-template': { 'position': 'right' } } }], "widget": "add-widget-by-prop", "value": "listtemplate" }
  },
  "wm.list.native_mobile": {
    "class": { "type": "string", "pattern": classRegex },
    "fontunit": { "type": "string", "options": ["em", "px", "pt"], "value": "px", "hidelabel": true, "widget": "icons-radio"},
    "itemkey": {"type": "string", "bindable": "in-bound",},
    "enablereorder": { "show": false },
    "onReorder": { "show": false },
    "statehandler": { "show": false },
    "onPaginationchange": { "show": false },
    "navigation": {"type": "select-by-object", "options": [{'value': 'Scroll', 'label': 'Infinite Scroll'}, {'value': 'None', 'label': 'None'}, {'value': 'On-Demand', 'label': 'On Demand'}], "value": "None"},
    "navigationalign": { "show": false },
    "collapsible": { "show": false, "ignore": true },
    "showcount": { "show": false, "ignore": true },
    "paginationclass": { "show": false },
    "onSetrecord": { "show": false },
    "templateview": { "show": false },
    "showrecordcount": { "show": false },
    "horizontalalign": { "show": false },
    "allowpagesizechange": { "show": false },
    "disableitem": { "show": false },
    "pagesize": { "type": "number", "value": 20 ,"show": false },
    "backgroundrepeat": { "show": false },
    "backgroundattachment": { "show": false },
    "numberofskeletonitems":{"type": "number", "value": "3"},
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "triggeronrenderwhenhidden": { "type": "boolean" },
    "disableitemselect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "onDeselect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "horizontalscrolltoitem": { "type": "boolean", "value": true },
    "responsive": {"type": "boolean", "value": false},
    "fallback": {"type": "boolean", "value": true}
  },
  "wm.list.web_prism": {
    "itemsperrow": { "type": "string", "widget": "device-config", "widthHeader": "Items per row", "deviceHeader": "Device", "deviceSizes": ['1', '2', '3', '4', '6', '12'], "tableClass": "wm-table-dark", "showAutoResponsiveToggle": true },
  },
  "wm.medialist": {
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "thumbnailurl": { "type": "list", "options": ["All Fields"], "value": "All Fields", "datasetfilter": "terminals" },
    "mediaurl": { "type": "list", "options": ["All Fields"], "value": "All Fields", "datasetfilter": "terminals" },
    "layout": { "type": "list", "options": ["Single-row", "Multi-row"], "value": "Single-row" },
    "tabindex": { "type": "number", "value": "0" },
    "currentItem": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "getTypeFrom": "dataset" }
  },
  "wm.medialist.mobile": {
    "offline": { "type": "boolean", "value": true }
  },
  "wm.livefilter": {
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "autocomplete": { "type": "boolean", "value": true, "showindesigner": true },
    "captionsize": { "type": "string", "value": "", "show": false },
    "captionalign": { "type": "string", "options": ["left", "center", "right"], "value": "left", "showindesigner": true, "widget": "icons-align" },
    "captionposition": { "type": "string", "options": ["left", "right", "top", "floating"], "value": "left", "showindesigner": true, "widget": "toggle-radio", "prefix": "position-" },
    "captionwidth": { "type": "string", "widget": "device-config", "value": "xs-12 sm-3 md-3 lg-3", "showindesigner": true, "widthHeader": "Column Width", "deviceHeader": "Device", "deviceSizes": columnWidths },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "bindInfo": {evaulateBindings: true, invokeVariable: true} },
    "advancedsettings": { "type": "button", "hidelabel": true, "iconclass": "web-service" },
    "result": { "type": "object", "bindable": "out-bound", "isList": true, "widget": "string", "show": "false", "getTypeFrom": "dataset" },
    "pagesize": { "type": "number", "value": 20 },
    "horizontalalign": { "type": "string", "options": ["left", "center", "right"], "widget": "icons-align", "show": false },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "value": "wi wi-filter-list", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "autoupdate": { "type": "boolean", "showindesigner": true },
    /* Events */
    "onBeforeservicecall": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onError": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSuccess": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "tabindex": { "type": "number", "value": "0" },
    "collapsible": { "type": "boolean", "showindesigner": true },
    "expanded": { "type": "boolean", "value": true, "showindesigner": true },
    "enableemptyfilter": { "type": "select-all", "options": ["null", "empty"], "displaytype": "block", "value": " ", "showindesigner": true },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "margin": { "type": "string", "widget": "box-model" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "filterWidgets": { "type": "object", "bindable": "in-out-bound", "show": false, "widget": "string", "isWidgetMap": true }
  },
  'wm.livefilter.mobile': {
    "captionwidth": { "type": "string", "widget": "device-config", "value": "xs-4 sm-4 md-4 lg-4", "showindesigner": true, "widthHeader": "Column Width", "deviceHeader": "Device", "deviceSizes": columnWidths }
  },
  "wm.search": {
    "datavalue": { "type": "string, object", "widget": "string", "bindable": "in-out-bound", "getTypeFrom": "dataset" },
    "result": { "type": "array", "value": [], "bindable": "out-bound", "getTypeFrom": "dataset" },
    "query": { "type": "string", "bindable": "out-bound" },
    "searchkey": { "type": "string", "widget": "select-all", "datasetfilter": "custom" },
    "displaylabel": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" },
    "displayimagesrc": { "type": "string", "widget": "list", "options": [""], "bindable": "in-bound", "bindonly": "expression", "datasetfilter": "terminals" },
    "datafield": { "type": "list", "options": ["All Fields"], "value": "All Fields", "bindable": "in-bound", "datasetfilter": "terminals", "allfields": true },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "limit": { "type": "number" },
    "searchon": { "type": "select-by-object", "options": [{ "label": "Typing", "value": "typing" }, { "label": "On search icon click", "value": "onsearchiconclick" }], "value": "typing", "show": false },
    "placeholder": { "type": "string", "value": "Search", "bindable": "in-bound" },
    "onBeforeservicecall": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSubmit": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onClear": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "showclear": { "type": "boolean", "value": false, "show": true },
    "tabindex": { "type": "number", "value": "0" },
    "minchars": { "type": "number" },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'inline-block' },
    "width": { "type": "string", "pattern": dimensionRegex },
    "shortcutkey": { "type": "string" },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["input-group-sm", "input-group-lg"] },
    "casesensitive": { "type": "boolean", "show": "false", "value": false },
    "showsearchicon": { "type": "boolean", "show": "false", "value": false },
    /* searchbar in mobile-navbar*/
    "navsearchbar": { "type": "string", "show": "false" },
    "readonly": { "type": "boolean", "bindable": "in-bound" },
    "type": { "type": "string", "widget": "list", "options": ["search", "autocomplete"], "value": "search", "show": true },
    "orderby": { "type": "list", "widget": "order-by", "datasetfilter": "terminals" },
    "loadingdatamsg": { "type": "string", "value": "Loading items...", "bindable": "in-bound" },
    "datacompletemsg": { "type": "string", "value": "No more data to load", "bindable": "in-bound" },
    "height": { "type": "string", "pattern": dimensionRegex },
    "imagewidth": { "type": "string", "value": "16px" },
    "onClick": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onTap": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onMouseenter": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onMouseleave": { "type": "event", "options": widgetEventOptions, "widget": "eventlist", "show": false },
    "onChange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "debouncetime": { "type": "number", "value": "250", "show": true },
    "matchmode": { "type": "select-by-object", "options": matchModes, "value": "startignorecase", "show": true },
    "groupby": { "type": "list", "show": true, "widget": "list-typeahead", "datasetfilter": "terminals" },
    "match": { "type": "list-group", "nonGroupOptions": timeNonGroupOptions, "options": timeGroupOptions, "show": false, "value": "word", "datasetfilter": "none" },
    "dateformat": { "type": "list", "options": [], "widget": "date-time-patterns", "show": false },
    "onDatasetready": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "clearsearchiconclass": { "type": "string", "value": "wi wi-close", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Clear Search Icon Class" },
    "backsearchiconclass": { "type": "string", "value": "wi wi-arrow-left", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Back Search Icon Class" },
    "searchiconclass": { "type": "string", "value": "wm-sl-l sl-search", "widget": "select-icon", "bindable": "in-out-bound", "pattern": classRegex, "label": "Search Icon Class", "show": false },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.search.native_mobile": {
    "groupby": { "show": false },
    "orderby": { "show": false },
    "loadingdatamsg": { "show": false },
    "onBeforeservicecall": { "show": false },
    "skeletonwidth": {"type": "string", "pattern": dimensionRegex},
    "skeletonheight": {"type": "string", "pattern": dimensionRegex},
    "showskeleton":  {"type": "boolean", "value": false},
    "arialabel": {"show": false},
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "accessibilityrole": { "type": "list", "bindable": "in-bound","options": accessibilityRoleOptions, "displayName": "Accesssibility Role", "value": "search"},
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.chart": {
    "title": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "subheading": { "type": "string", "bindable": "in-bound", "showPrettyExprInDesigner": true },
    "iconclass": { "type": "string", "widget": "select-icon", "bindable": "in-bound", "pattern": classRegex, "label": 'LABEL_TITLEICONCLASS' },
    "advancedsettings": { "type": "button", "hidelabel": true, "iconclass": "web-service" },
    "height": { "type": "string", value: "210px", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "type": { "type": "string", "widget": "list", "options": ["Area", "Bar", "Bubble", "Column", "Cumulative Line", "Donut", "Line", "Pie"], "bindable": "in-out-bound", "show": false },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string", "bindInfo": {evaulateBindings: true, invokeVariable: true}},
    "formattype": { "type": "select-by-object", "options": [{ "label": "toNumber", "value": "integer" }, { "label": "toDate", "value": "date" }], "value": "", "displayfield": "label", "datafield": "value", "showindesigner": false },
    "xaxisdatakey": { "type": "list", "widget": "list", "datasetfilter": "custom" },
    "xaxislabel": { "type": "string", "bindable": "in-bound" },
    "xunits": { "type": "string" },
    "xnumberformat": { "type": "list-group", "options": numberFormatOptions },
    "xdateformat": { "type": "list-group", "options": dateOptions },
    "yaxisdatakey": { "type": "list", "widget": "multi-select", "datasetfilter": "custom" },
    "yaxislabel": { "type": "string", "bindable": "in-bound" },
    "yunits": { "type": "string" },
    "ynumberformat": { "type": "list-group", "options": numberFormatOptions },
    "bubblesize": { "type": "string", "widget": "list", "datasetfilter": "custom" },
    "shape": { "type": "string", "widget": "list", "options": ["circle", "cross", "diamond", "random", "square", "triangle-down", "triangle-up"], value: "circle" },
    "show": { "type": "boolean", "value": true, "bindable": "in-out-bound" },
    "highlightpoints": { "type": "boolean" },
    "linethickness": { "type": "string" },
    "tooltips": { "type": "boolean", "value": true },
    "showlegend": { "type": "list", "options": ["hide", "top", "bottom"], "value": "top" },
    "showxaxis": { "type": "boolean", "value": true },
    "showyaxis": { "type": "boolean", "value": true },
    "legendtype": { "type": "list", "options": ["classic", "furious"], "value": "furious", "disabled": false },
    "showvalues": { "type": "boolean", "value": false },
    "showlabels": { "type": "list", "options": ['hide', 'inside', 'outside'], "value": "outside" },
    "viewtype": { "type": "list", "options": ['Grouped', 'Stacked'], "value": "Grouped" },
    "interpolation": { "type": "list", "options": ['linear', 'cardinal', 'step'], "value": "linear" },
    "areaviewtype": { "type": "list", "options": ['stack', 'stream', 'expand'], "value": "stack" },
    "staggerlabels": { "type": "boolean", "value": false },
    "reducexticks": { "type": "boolean", "value": true },
    "labeltype": { "type": "select-by-object", "value": "percent", "options": [{ "labelkey": "LABEL_KEY", "value": "key" }, { "labelkey": "LABEL_VALUE", "value": "value" }, { "labelkey": "LABEL_PERCENTAGE", "value": "percent" }, { "labelkey": "LABEL_KEY_VALUE", "value": "key-value" }] },
    "labelthreshold": { "type": "number", "value": 0.01, "show": false },
    "offset": { "type": "string", "widget": "box" },
    "offsettop": { "type": "number", "value": 25, "pattern": numberRegex },
    "offsetbottom": { "type": "number", "value": 55, "pattern": numberRegex },
    "offsetleft": { "type": "number", "value": 75, "pattern": numberRegex },
    "offsetright": { "type": "number", "value": 25, "pattern": numberRegex },
    "barspacing": { "type": "list", "options": ["small", "medium", "large"], "value": "medium" },
    "donutratio": { "type": "list", "options": ["small", "medium", "large"], "value": "medium" },
    "centerlabel": { "type": "string", "bindable": "in-bound", "show": false },
    "showlabelsoutside": { "type": "boolean", "value": true },
    "xaxislabeldistance": { "type": "number", "value": 12 },
    "yaxislabeldistance": { "type": "number", "value": 12 },
    "showxdistance": { "type": "boolean", "value": false },
    "showydistance": { "type": "boolean", "value": false },
    "aggregation": { "type": "list", "options": ["average", "count", "maximum", "minimum", "none", "sum"], "value": "none", "disabled": true, show: true },
    "aggregationcolumn": { "type": "list", "widget": "list", "disabled": true, "datasetfilter": "custom", show: true },
    "groupby": { "type": "list", "widget": "multi-select", "datasetfilter": "custom", show: true },
    "orderby": { "type": "list", "widget": "order-by", "datasetfilter": "custom", show: true },
    "theme": { "type": "list", "options": ["Annabelle", "Azure", "Flyer", "GrayScale", "Luminosity", "Mellow", "Orient", "Retro", "Terrestrial"] },
    "customcolors": { "type": "array", "bindable": "in-bound", "widget": "string" },
    "labelcolors": { "type": "array", "bindable": "in-bound", "widget": "string" },
    "nodatamessage": { "type": "string", "value": "No Data Available.", "bindable": "in-bound", "show": false },
    "xdomain": { "type": "list", "options": ["Default", "Min"], "value": "Default" },
    "ydomain": { "type": "list", "options": ["Default", "Min"], "value": "Default" },
    /**Style**/
    "borderwidth": { "type": "string", "widget": "box-model" },
    "borderstyle": { "type": "string", "options": ["dashed", "dotted", "none", "solid"], "widget": "border-style" },
    "bordercolor": { "type": "string", "widget": "color" },
    "backgroundcolor": { "type": "string", "widget": "color" },
    "backgroundimage": { "type": "string", "bindable": "in-bound" },
    "color": { "type": "string", "widget": "color" },
    "selecteditem": { "type": "object", "bindable": "out-bound", "widget": "string", "getTypeFrom": "dataset" },
    "onBeforerender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onTransform": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onSelect": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "loadingdatamsg": { "type": "string", "value": "Loading...", "bindable": "in-bound", "show": false }
  },
  "wm.chart.native_mobile": {
    "aggregation": { "show": false, "hidelabel": true,"showindesigner":true },
    "aggregationcolumn": { "show": false, "hidelabel": true,"showindesigner":true},
    "groupby": { "show": false, "hidelabel": true },
    "orderby": { "show": false, "hidelabel": true,"showindesigner":true },
    "yaxislabeldistance": { "type": "number", "value": 50 },
    "offsettop": { "type": "number", "value": 70, "pattern": numberRegex },
    "offsetbottom": { "type": "number", "value": 50, "pattern": numberRegex },
    "offsetleft": { "type": "number", "value": 65, "pattern": numberRegex },
    "offsetright": { "type": "number", "value": 25, "pattern": numberRegex },
    "legendtype": { "show": false, "hidelabel": true, "showindesigner": false },
    "tooltips": { "type": "boolean", "value": true },
    "ynumberformat": { "type": "list-group", "options": numberFormatOptions },
    "xnumberformat": { "show": false, "hidelabel": true, "showindesigner": false },
    "staggerlabels": { "show": false, "hidelabel": true, "showindesigner": false },
    "areaviewtype": { "show": false, "showindesigner": false },
    "skeletonanimationresource": {"type": "string", "bindable": "in-out-bound"},
    "skeletonanimationspeed": {"type": 'number', "value": 1},
    "accessibilitylabel": { "type": "string", "bindable": "in-bound", "displayName": "Accesssibility Label" },
  },
  "wm.pagination": {
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "result": { "type": "object", "bindable": "out-bound", "widget": "string", "show": "false", "getTypeFrom": "dataset" },
    "onSetrecord": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "onPaginationchange": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "tabindex": { "type": "number", "value": "0" },
    "navigationsize": { "type": "list", "options": ["small", "large"], "show": false },
    "class": { "type": "string", "pattern": classRegex, "widget": "list-picker", "options": ["pagination-sm", "pagination-lg"] }
  },
  "wm.login": {
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "errormessage": { "type": "string", "bindable": "in-bound" },
    "onSubmit": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
  "wm.login.native_mobile": {
    "errormessage": { "show": false },
    "onBeforerender": { "show": false },
  },
  "wm.pagecontainer": {
    "content": { "type": "string", "options": [], "widget": "pages-list", value: "", "bindable": "in-bound", "bindInfo": {evaulateBindings: true, handleEmptyEvaluation: true}},
    "onLoad": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" }
  },
    "wm.lottie": {
    "height": {"type": "string", "pattern": dimensionRegex},
    "width": {"type": "string", "pattern": dimensionRegex},
    "source": {"type": "string", "bindable": "in-out-bound", "label": "LOTTIE_SOURCE"},
    "autoplay": {"type": "boolean", "value": false, "label": "LOTTIE_AUTOPLAY"},
    "loop": {"type": "boolean", "value": false, "label": "LOTTIE_LOOP"},
    "speed": {"type": "number", "bindable": "in-bound", "value": 1, "label": "LOTTIE_SPEED"},
    "backgroundcolor": {"type": "string", "widget": "color"},
    "backgroundgradient": {"type": "string"},
    "backgroundimage": {"type": "string", "bindable": "in-bound"},
    "backgroundrepeat": {"type": "list", "options": ["no-repeat", "repeat", "repeat-x", "repeat-y"]},
    "backgroundsize": {"type": "string", "hint": "width, height"},
    "backgroundposition": {"type": "string", "hint": "top, left"},
    "onReady": {"type": "event", "options": widgetEventOptions, "widget": "eventlist", "label": "LOTTIE_ONREADY"},
    "onPause": {"type": "event", "options": widgetEventOptions, "widget": "eventlist", "label": "LOTTIE_ONPAUSE"},
    "onPlay": {"type": "event", "options": widgetEventOptions, "widget": "eventlist", "label": "LOTTIE_ONPLAY"},
    "onComplete": {"type": "event", "options": widgetEventOptions, "widget": "eventlist", "label": "LOTTIE_ONCOMPLETE"},
  },

  "wm.video": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "mp4format": { "type": "string", "value": "", "bindable": "in-out-bound" },
    "oggformat": { "type": "string", "value": "", "bindable": "in-out-bound" },
    "webmformat": { "type": "string", "value": "", "bindable": "in-out-bound" },
    "subtitlelang": { "type": "string", "value": "en", "bindable": "in-out-bound" },
    "subtitlesource": { "type": "string", "value": "", "bindable": "in-out-bound" },
    "videoposter": { "type": "string", "value": "resources/images/imagelists/default-image.png", "bindable": "in-out-bound" },
    "controls": { "type": "boolean" },
    "videosupportmessage": { "type": "string", "bindable": "in-bound", "value": "Your browser does not support the video tag." },
    "autoplay": { "type": "boolean" },
    "loop": { "type": "boolean" },
    "muted": { "type": "boolean" },
    "videopreload": { "type": "list", "options": ["none", "metadata", "auto"], "value": "none" },
    "tabindex": { "type": "number", "value": "0" },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'inline-block' },
    "class": { "type": "string", "pattern": classRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE }
  },
  "wm.video.native_mobile": {
    "oggformat": {"show": false},
    "subtitlelang": {"show": false},
    "subtitlesource": {"show": false},
    "videosupportmessage":  {"show": false},
    "videopreload": {"show": false},
    "tabindex": {"show": false},
    "controls":  {"type": "boolean","value": true},
    "showdefaultvideoposter":  {"type": "boolean","value": true},
  },
  "wm.audio": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "mp3format": { "type": "string", "value": "", "bindable": "in-out-bound" },
    "controls": { "type": "boolean" },
    "audiosupportmessage": { "type": "string", "bindable": "in-bound", "value": "Your browser does not support the audio tag." },
    "autoplay": { "type": "boolean" },
    "loop": { "type": "boolean" },
    "muted": { "type": "boolean", "value": false },
    "audiopreload": { "type": "list", "options": ["none", "metadata", "auto"], "value": "none" },
    "tabindex": { "type": "number", "value": "0" },
    "showindevice": { "type": "select-all", "options": showInDeviceOptions, "value": "all", "displaytype": 'inline-block' },
    "class": { "type": "string", "pattern": classRegex },
    "show": { "type": "boolean", "value": true, "bindable": "in-bound" },
    "height": { "type": "string", "pattern": dimensionRegex },
    "width": { "type": "string", "pattern": dimensionRegex },
    "accessroles": { "type": "access-roles-select", "options": roles, "value": EVERYONE },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" }
  },
  "wm.audio.native_mobile": {
    "audiosupportmessage": {"show": false},
    "audiopreload": {"show": false},
    "tabindex": {"show": false},
    "arialabel": {"show":false },
  },
  "wm.progress.bar": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "minvalue": { "type": "number", "value": 0, "bindable": "in-bound" },
    "maxvalue": { "type": "number", "value": 100, "bindable": "in-bound" },
    "datavalue": { "type": "number, string", "bindable": "in-out-bound", "widget": "string" },
    "dataset": { "type": "array, object", "bindable": "in-bound", "widget": "string" },
    "displayformat": { "type": "list", "options": ["9", "9.9", "9.99", "9.999", "9%", "9.9%", "9.99%", "9.999%"] },
    "captionplacement": { "type": "list", "options": ["inside", "hidden"], "value": "hidden" },
    "type": { "type": "list", "options": ["default", "default-striped", "success", "success-striped", "info", "info-striped", "warning", "warning-striped", "danger", "danger-striped"], "value": "default", "bindable": "in-bound", "hideInPrism" : true },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "width": { "type": "string", "pattern": dimensionRegex },
    "height": { "type": "string", "pattern": dimensionRegex },

    /* ---- styles ----*/
    "margin": { "type": "string", "widget": "box-model" },
    "tabindex": { "type": "number", "value": "0" }
  },
  "wm.progress.bar.native_mobile": {
    "dataset": { "show": false },
    "displayformat": { "show": false },
    "captionplacement": { "show": false },
    "type": { "type": "list", "options": ["default", "success", "info", "warning", "danger"], "value": "default", "bindable": "in-bound", "hideInPrism" : true },
    "arialabel": { "show": false },
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
    "showtooltip": { "label": "Show Tooltip", "type": "boolean", "value": false, "bindable": "in-bound" },
    "tooltipposition": { "label": "Tooltip position", "type": "list", "options": ["up", "down", "left", "right"], "value": "up", "bindable": "in-bound" },
    "onTooltiptext": { "label": "On Tooltip Text", "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
  },
  "wm.progress.circle": {
    "hint": { "type": "string", "bindable": "in-bound" },
    "title": { "type": "string", "bindable": "in-bound" },
    "subtitle": { "type": "string", "bindable": "in-bound" },
    "percentagevalue": { "type": "number", "bindable": "out-bound" },
    "minvalue": { "type": "number", "value": 0, "bindable": "in-bound" },
    "maxvalue": { "type": "number", "value": 100, "bindable": "in-bound" },
    "datavalue": { "type": "number, string", "value": 30, "bindable": "in-bound", "widget": "string" },
    "displayformat": { "type": "list", "options": ["9", "9.9", "9.99", "9.999", "9%", "9.9%", "9.99%", "9.999%"], "value": "9%" },
    "captionplacement": { "type": "list", "options": ["inside", "hidden"], "value": "inside" },
    "type": { "type": "list", "options": ["default", "success", "info", "warning", "danger"], "value": "default", "bindable": "in-bound", "hideInPrism" : true },
    "onBeforerender": { "type": "event", "options": widgetEventOptions, "widget": "eventlist" },
    "arialabel": { "type": "string", "bindable": "in-bound", "displayName":"aria-label" },
    "width": { "type": "string", "value": "200px", "pattern": dimensionRegex },
    "height": { "type": "string", "value": "200px", "pattern": dimensionRegex },
    /* ---- styles ----*/
    "margin": { "type": "string", "widget": "box-model" },
    "tabindex": { "type": "number", "value": "0" }
  },
  "wm.progress.circle.native_mobile": {
    "displayformat": { "show": false },
    "onBeforerender": { "show": false },
    "type": { "type": "list", "options": ["default", "success", "info", "warning", "danger"], "value": "default", "bindable": "in-bound", "hideInPrism" : true },
    "arialabel": { "show": false },
    "disabletoucheffect": { "type": "boolean", "value": false, "bindable": "in-bound" },
  },
  "wm.template": {
    "header": { "type": "list", "options": [], "widget": "templates-list", value: "_nocontent" },
    "topnav": { "type": "list", "options": [], "widget": "templates-list", value: "_nocontent" },
    "leftnav": { "type": "list", "options": [], "widget": "templates-list", value: "_nocontent" },
    "rightnav": { "type": "list", "options": [], "widget": "templates-list", value: "_nocontent" },
    "footer": { "type": "list", "options": [], "widget": "templates-list", value: "_nocontent" }
  }
}
}

export const propertyGroups: any[] = [
  { "name": "properties", "parent": "", "show": true, "feature": "project.editor.design.basic", "iconClass": "wms wms-properties" },
  { "name": "styles", "parent": "", "show": true, "feature": "project.editor.design.style", "iconClass": "wms wms-styles" },
  { "name": "events", "parent": "", "show": true, "feature": "project.editor.design.events", "iconClass": "wms wms-events" },
  { "name": "device", "parent": "", "show": true, "feature": "project.editor.design.mobile", "iconClass": "wms wms-devices" },
  { "name": "security", "parent": "", "show": true, "feature": "project.editor.design.security", "iconClass": "wms wms-security" },
  { "properties": ["widget", "caption", "gridcaption", "title", "subtitle", "displayname", "heading", "subheading", "name", "debugurl", "type", "inputtype", "accept", "filetype", "extensions", "placeholder", "maxplaceholder", "currency", "description", "message", "oktext", "canceltext", "servicevariabletotrack", "valuetype", "alerttype", "iframesrc", "webviewsrc", "insert", "dropposition", "spacing", "advancedsettings", "addchild", "badgevalue", "badgetype", "homelink", "addproperty"], "parent": "properties" },
  { "name": "accessibility", "properties": [ "tabindex", "shortcutkey", "helptext", "headinglevel", "arialabel", "alttext", "accessible","accessibilitylabel","hint","accessibilityrole"], "parent": "properties" },
  { "name": "captionforsteps", "properties": ["nextbtnlabel", "previousbtnlabel", "donebtnlabel", "cancelbtnlabel"], "parent": "properties" },
  { "name": "picture", "properties": ["imageheight", "picturesource", "pictureplaceholder", "pictureaspect", "resizemode", "shape", "picturetitle","source", "aspectratio"], "parent": "properties" },
  { "name": "position", "properties": ["position", "zindex"], "parent": "properties" },
  { "name": "layout", "properties": ["direction", "width", "height", "clipcontent", "overflow", "alignment", "gap", "columngap", "wrap", "padding", "filelistheight", "treeicons", "menulayout", "menuposition", "levels", "imgsrc", "layoutkind", "columns", "layout", "stepstyle", "actionsalignment", "defaultstep", "defaultstepindex", "navtype", "stacked", "justified", "formlayout", "showheader", "header", "topnav", "leftnav", "rightnav", "footer", "addrow", "addcolumn", "popoverwidth", "popoverheight", "tabsposition", "gridsearch", "filtermode", "searchlabel", "filteronkeypress", "inputwidth", "sheet", "sheetposition", "navheight","bottomsheetheightratio","expand","bottomsheetexpandedheightratio"], "parent": "properties" },
  { "name": "video", "properties": ["videoposter", "mp4format", "oggformat", "webmformat", "videopreload", "videosupportmessage", "subtitlesource", "subtitlelang", "showdefaultvideoposter"], "parent": "properties" },
  { "name": "audio", "properties": ["mp3format", "audiopreload", "audiosupportmessage"], "parent": "properties" },
  { "name": "content", "properties": ["contentsource", "content", "inlinecontent", "url"], "parent": "properties" },
  { "name": "partialparams", "properties": [], "parent": "properties" },
  { "name": "display", "properties": ["modal", "vertical", "avatar"], "parent": "properties" },
  { "name": "dataset", "properties": ["service", "operation", "dataset", "options", "hyperlink", "formfield", "metadata", "searchkey", "matchmode", "displaylabel", "displayimagesrc", "usekeys", "datafield", "displayfield", "displayexpression", "groupby", "match", "scale", "dateformat", "aggregation", "aggregationcolumn", "orderby", "compareby", "orderbycolumn", "nodelabel", "nodeicon", "nodechildren", "nodeid", "nodeaction", "nodeclick", "thumbnailurl", "mediaurl","itemkey"], "parent": "properties" },
  { "name": "values", "properties": ["datavalue", "defaultvalue", "maxdefaultvalue", "formdata", "discretevalues", "integervalues", "minimum", "maximum", "defaultcolor", "checkedvalue", "uncheckedvalue"], "parent": "properties" },
  { "name": "valuedisplay", "properties": ["viewmode", "datepattern", "timepattern", "hourstep", "minutestep", "limit", "showdateformatasplaceholder","showampmbuttons"], "parent": "properties" },
  { "name": "output", "properties": ["outputformat"], "parent": "properties" },
  { "name": "eventsdata", "properties": ["eventtitle", "eventstart", "eventend", "eventallday", "eventclass"], "parent": "properties" },
  { "name": "actions", "properties": ["actions", "itemid", "itemlabel", "itemhint", "itemicon", "itemlink", "itemaction", "userrole", "itembadge", "itemchildren", "isactive"], "parent": "properties" },
  { "name": "xaxis", "properties": ["xaxisdatakey"], "parent": "properties" },
  { "name": "yaxis", "properties": ["yaxisdatakey"], "parent": "properties" },
  { "name": "zaxis", "properties": ["bubblesize"], "parent": "properties" },
  { "name": "validation", "properties": ["required", "validationmessage", "regexp", "mindate", "maxdate", "mintime", "maxtime", "excludedays", "excludedates", "novalidate", "validationtype", "maxchars", "limitdisplaytext", "minvalue", "maxvalue", "step", "markerlabeltext"], "parent": "properties" },
 { "name": "behavior", "properties": ["flexgrow","cache","refreshdataonattach","method","action","enctype","target","defaultview","templateview","defaultmode","defaultpaneindex","pollinterval","radiogroup","viewgroup","showdropdownon","dataentrymode","showcustompicker","showweeks","showbuttonbar","autofocus","readonly","ignoreparentreadonly","editmode","scrolldelay","scrollamount","direction","multiple","maxsize","inputposition","allowonlyselect","enablereorder","statehandler","fileuploadmessage","mode","sticky","show","deferload","hideclose","calendartype","controls","view","disabled","showclear","disableitem","pagesize","dynamicslider","selectionclick","closeothers","collapsible","showcount","enablefullscreen","enablefullswipe","skipscripteventtrigger","lock","freeze","autoscroll","closable","showactions","expanded","destroyable","showDirtyFlag","link","linktarget","uploadpath","contenttype","origin","destination","maxfilesize","isdefaulttab","disablenext","disableprevious","disabledone","enabledone","enableskip","cancelable","enablenext","showalltitles","isdefaultpane","autocomplete","autotrim","showpreview","autoplay","loop","muted","xpadding","ypadding","interaction","autoopen","autoclose","showonhover","transition","animation","animateitems","animationinterval","leftnavpaneliconclass","backbutton","backbuttoniconclass","backbuttonlabel","searchbutton","searchon","position","debouncetime","morebuttoniconclass","inputmode","decimalplaces","trailingzero","menuiconclass","morebuttonlabel","capturetype","loadmode","loaddelay","showcaptions","multiselect","multiselecttitle","multiselectarialabel","headerselectall","radioselect","radioselecttitle","radioselectarialabel","enablesort","enablecolumnselection","gridfirstrowselect","isrowselectable","allowpagesizechange","pagesizeoptions","selectfirstitem","selectionlimit","formposition","enableemptyfilter","autoupdate","displayformat","showdisplayformaton","captionplacement","updateon","updatedelay","actionlink","actiontitle","offline","encodeurl","keyboard","barcodeformat","minchars","selectionmode","range","showmarkers","showtooltip","tooltipposition","autocapitalize","enablescroll","speed","disabletoucheffect","hidehorizontalscrollbar","horizontalscrolltoitem","autotabactivation","triggeronrenderwhenhidden","disableitemselect","submitondone","layoutposition","returnkeytype","visible","stopatlast","showonrender","disableswipedownclose","bottomsheetminimumheight","enabledragsettle","disablescrollonrest","scrollable","enablegestures"], "parent": "properties" },
  {"name": "skeleton", "properties": ["skeletonwidth", "skeletonheight", "multilineskeleton", "showskeletonchildren", "skeletonanimationresource", "skeletonanimationspeed", "numberofskeletonitems", "showskeleton"], "parent": "properties"},
  {"name": "scrollbehavior", "properties": ["onscroll"], "parent": "properties"},
  {"name": "systembarscustomisation", "properties": ["statusbarstyle"], "parent": "properties"},
  { "name": "popoverbehavior", "properties": ["popoverplacement", "contentanimation", "popoverarrow", "popoverautoclose"], "parent": "properties" },
  { "name": "navigation", "properties": ["navigation", "shownavigation", "showrecordcount", "navigationalign", "ondemandmessage", "showviewlessbutton", "viewlessmessage", "allowpagesizechange", "pagesizeoptions"], "parent": "properties" },
  { "name": "searchproperties", "properties": ["searchbuttoniconclass", "searchbuttonlabel", "searchplaceholder"], "parent": "properties" },
  { "name": "datatable", "properties": ["showrowindex", "exportformat", "exportdatasize"], "parent": "properties" },
  { "name": "caption", "properties": ["captionalign", "captionposition", "captionsize", "captionwidth", "mineditorwidth"], "parent": "properties" },
  { "name": "graphics", "properties": ["imagelist", "imageindex", "checkediconclass", "paneicon", "loadingicon", "iconclass", "doneiconclass", "lefticonclass", "righticonclass", "leftbadge", "rightbadge", "selectediconclass", "iconsize", "iconurl", "iconwidth", "iconheight", "iconmargin", "iconposition", "image", "imagewidth", "activeiconclass", "inactiveiconclass", "clearsearchiconclass", "backsearchiconclass", "searchiconclass", "expandediconclass", "collapsediconclass", "textanimation", "animationspeed", "donebtniconclass", "handlesizeon", "handlesizeoff", "handlesizebounce", "bounceduration", "slideduration"], "parent": "properties" },
  { "name": "format", "properties": ["showtooltip", "horizontalalign", "verticalalign", "columnwidth", "xscolumnwidth", "taborder"], "parent": "properties" },
  { "name": "operations", "properties": ["insertrow", "deleterow", "updaterow", "submitbutton", "resetbutton"], "parent": "properties" },
  { "name": "message", "properties": ["messagelayout", "errormessage","confirmdelete", "nodatamessage", "loadingdatamsg", "insertmessage", "updatemessage", "deletemessage", "datacompletemsg", "postmessage"], "parent": "properties" },      { "name": "deletedialog", "properties": ["deleteoktext", "deletecanceltext"], "parent": "properties" },
  { "name": "designsystemproperty", "properties": ["leadingiconclass", "trailingiconclass", "supportingtext", "showicons", "starticon", "endicon", "rangelabelposition", "selectedicon", "unselectedicon", "layout"], "parent": "properties" },
  { "properties": ["variant"], "parent": "styles" },
  { "name": "textstyle", "properties": ["fontsize", "fontunit", "fontfamily", "color", "fontstyle", "fontweight", "textdecoration", "textalign", "whitespace"], "parent": "styles" },
  { "name": "backgroundstyle", "properties": ["backgroundcolor", "backgroundimage", "backgroundrepeat", "backgroundresizemode", "backgroundposition", "backgroundsize", "backgroundattachment"], "parent": "styles" },
  { "name": "border", "properties": ["bordercolor", "borderstyle", "borderwidth"], "parent": "styles" },
  { "name": "displaystyle", "properties": ["iconcolor", "padding", "margin", "opacity", "overflow", "cursor", "zindex", "visibility", "display"], "parent": "styles" },
  { "name": "additional", "properties": ["class", "conditionalclass", "conditionalstyle", "menuclass", "listclass", "itemclass", "chipclass", "paginationclass", "gridclass", "contentclass",], "parent": "styles" },  
  { "name": "prefablifecycleevents", "properties": ["onAttach", "onDetach", "onLoad", "onDestroy"], "parent": "events" },
  { "name": "event", "properties": ["onChange", "onFocus", "onBlur", "onOrientationchange", "onResize"], "parent": "events" },
  { "name": "mouseevents", "properties": ["onClick", "onDblclick", "onMousedown", "onMouseup", "onMouseover", "onMouseout", "onMousemove", "onMouseenter", "onMouseleave"], "parent": "events", "platforms": [PLATFORM_TYPE.WEB, PLATFORM_TYPE.DEFAULT] },
  { "name": "touchevents", "properties": ["onTap", "onDoubletap", "onLongtap", "onTouchstart", "onTouchend", "onSwipeup", "onSwipedown", "onSwipeleft", "onSwiperight", "onPinchin", "onPinchout"], "parent": "events" },
  { "name": "keyboardevents", "properties": ["onKeydown", "onKeypress", "onKeyup"], "parent": "events" },
  {
    "name": "callbackevents", "properties": ["onReady", "onPause", "onPlay", "onStart", "onComplete", "onBeforeupdate", "onBeforeadd", "onAdd", "onBeforeremove", "onRemove", "onShow", "onHide", "onOk", "onBeforesubmit", "onSubmit", "onCancel", "onClose", "onOpened", "onExpand", "onCollapse", "onRowclick", "onRowselect", "onRowdeselect", "onBeforeselect", "onSelect", "onChipclick", "onChipselect", "onDeselect", "onBeforerender",
      "onProgress", "onTransform", "onAbort", "onSort", "onGridbuttonclick", "onHeaderclick", "onRowdblclick", "onColumnselect", "onColumndeselect", "onBeforeformrender", "onFormrender", "onBeforerowdelete", "onRowdelete", "onBeforerowinsert", "onRowinsert", "onBeforerowupdate", "onRowupdate", "onResult", "onSuccess", "onError", "onBeforedelete", "onDelete", "onBeforeservicecall", "onDatasetready", "onActionsclick", "onClear",
      "onBeforesegmentchange", "onSegmentchange", "onSearch", "onBackbtnclick", "onEventdrop", "onEventresize", "onEventclick", "onEventrender", "onViewrender", "onBeforereorder", "onReorder", "onSelectionlimitexceed", "onFullscreen", "onExitfullscreen", "onNext", "onPrev", "onSkip", "onDone", "onBeforedatarender","onDraghandleiconclick","onDatarender", "onRender", "onPaginationchange", "onPulltorefresh", "onSetrecord", "onBeforenavigate", "onBeforeexport", "onBeforefilter", "onBeforeload", "onDateclick", "onTooltiptext"], "parent": "events"
  },
  { "name": "designsystemevents", "properties": ["onLeadingIconClick", "onTrailingIconClick"], "parent": "events" },
  { "name": "security", "properties": ["accessroles"], "parent": "security" },
  { "name": "devicesize", "properties": ["showindevice", "itemsperrow", "responsive", "fallback"], "parent": "device" },
  { "name": "gridstyles", "properties": ['rowclass', 'rowngclass'], "parent": "properties" },
  { "name": "imageproperties", "properties": ["imagetargetwidth", "imagetargetheight", "imagequality", "imageencodingtype", "correctorientation", "sourcetype", "savetogallery", "allowedit"], "parent": "properties" },
  { "name": "dialogcustomization", "properties": ["dateheadertitle", "dateconfirmationtitle", "datecanceltitle", "timeheadertitle", "timeconfirmationtitle", "timecanceltitle"], "parent": "properties"}
];

export function getAdvancedPropertyGroups(){
  return [
    { "name": "chart", "show": true },
    { "name": "xaxis", "show": true, "icon": 'wi wi-border-bottom' },
    { "name": "yaxis", "show": true, "icon": 'wi wi-border-left' },
    { "name": "value", "show": true, "icon": 'wi wi-data-usage' },
    { "name": "", "properties": ["centerlabel"], "parent": "chart" },
    { "name": "colors", "properties": ["theme", "customcolors","labelcolors"], "parent": "chart" },
    { "name": "message", "properties": ["nodatamessage", "loadingdatamsg"], "parent": "chart" },
    { "name": "layout", "properties": ["offset"], "parent": "chart" },
    { "name": "legend", "properties": ["showlegend", "legendtype"], "parent": "chart" },
    { "name": "behavior", "properties": ["tooltips", "donutratio", "highlightpoints", "linethickness"], "parent": "chart" },
    { "name": "datarendering", "properties": ["viewtype", "interpolation", "areaviewtype"], "parent": "chart" },
    //x axis groups
    { "name": "", "properties": ["showxaxis", "xaxislabel", "xunits", "xaxislabeldistance", "xdomain", "showvalues", "staggerlabels", "reducexticks", 'barspacing', 'showxdistance'], "parent": "xaxis" },
    { "name": "xaxisformat", "properties": ["formattype", "xnumberformat", "xdateformat"], "parent": "xaxis" },
    //y axis groups
    { "name": "", "properties": ["showyaxis", "yaxislabel", "yunits", "yaxislabeldistance", "ydomain", 'showydistance'], "parent": "yaxis" },
    { "name": "yaxisformat", "properties": ["ynumberformat"], "parent": "yaxis" },
    //value groups
    { "name": "value", "properties": ['showlabels', 'labeltype'], "parent": "value" },
    { "name": "valueformat", "properties": ["ynumberformat"], "parent": "value" } 
  ];}

export let propertiesList: any = {
  'wm-page': { widget: 'wm.page', parent: ['wm.base.reusablewidget'] },
  'wm-page-content': { widget: 'wm.layouts.pagecontent', parent: ['wm.layouts', 'wm.base.events.touch', 'wm.scrollablecontainer'] },
  'wm-content': { widget: 'wm.layouts.content', parent: ['wm.layouts', 'wm.base.events.touch'] },
  'wm-partial': { widget: 'wm.partial', parent: ['wm.base.reusablewidget'] },
  'wm-prefab': { widget: 'wm.prefab', parent: ['wm.base'] },
  'wm-prefab-container': { widget: 'wm.prefab', parent: ['wm.base', 'wm.base.reusablewidget'] },
  'wmx-component': { widget: 'wmx.component', parent: ['wm.base'] },
  'wm-header': { widget: 'wm.header', parent: ['wm.layouts.header', 'wm.layouts', 'wm.base.events.touch'] },
  'wm-footer': { widget: 'wm.footer', parent: ['wm.layouts.footer', 'wm.layouts', 'wm.base.events.touch'] },
  'wm-right-panel': { widget: 'wm.right.panel', parent: ['wm.layouts.rightpanel', 'wm.layouts', 'wm.base.events.touch'] },
  'wm-left-panel': { widget: 'wm.left.panel', parent: ['wm.layouts.leftpanel', 'wm.layouts', 'wm.base.events.touch', 'wm.scrollablecontainer'] },
  'wm-top-nav': { widget: 'wm.top.nav', parent: ['wm.layouts.topnav', 'wm.layouts', 'wm.base.events.touch'] },
  ///  properties of From Widget  ///
  'wm-button': { widget: 'wm.button', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.advancedformwidgets', 'wm.base.events', 'wm.base.events.focus', 'wm.base.events.keyboard', 'wm.accessibility_basic'] },
  'wm-buttongroup': { widget: 'wm.buttongroup', parent: ['wm.base'] },
  'wm-repeat-template': { widget: '', parent: ['wm.base', 'wm.containers', 'wm.containers.layout'] },
  'wm-text': { widget: 'wm.text', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.editors', 'wm.base.editors.abstracteditors', 'wm.base.events.keyboard', 'wm.accessibility_basic'] },
  'wm-number': { widget: 'wm.number', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.editors', 'wm.base.editors.abstracteditors', 'wm.base.events.keyboard', 'wm.accessibility_basic'] },
  'wm-textarea': { widget: 'wm.textarea', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.editors', 'wm.base.editors.abstracteditors', 'wm.base.events.keyboard', 'wm.accessibility_basic'] },
  'wm-select': { widget: 'wm.select', parent: ['wm.base', 'wm.base.editors', 'wm.base.editors.abstracteditors', 'wm.base.editors.dataseteditors', 'wm.base.events.keyboard', 'wm.accessibility_basic'] },
  'wm-currency': { widget: 'wm.currency', parent: ['wm.base', 'wm.base.editors', 'wm.base.editors.abstracteditors', 'wm.accessibility_basic'] },
  'wm-chips': { widget: 'wm.chips', parent: ['wm.base', 'wm.base.editors.dataseteditors', 'wm.base.events.focus', 'wm.accessibility_basic'] },
  'wm-checkboxset': { widget: 'wm.checkboxset', parent: ['wm.base', 'wm.base.editors.dataseteditors', 'wm.accessibility_basic'] },
  'wm-checkbox': { widget: 'wm.checkbox', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.editors.abstracteditors', "wm.accessibility_basic"] },
  'wm-toggle': { widget: 'wm.checkbox', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.editors.abstracteditors', 'wm.accessibility_basic', 'wm.toggle'] },
  'wm-iconbutton-toggle': { widget: 'wm.checkbox', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.editors.abstracteditors', 'wm.accessibility_basic', 'wm.icon_button_toggle'] },
  'wm-switch': { widget: 'wm.switch', parent: ['wm.base', 'wm.base.editors.abstracteditors', 'wm.accessibility_basic'] },
  'wm-date': { widget: 'wm.date', parent: ['wm.base', 'wm.base.editors.abstracteditors', 'wm.base.datetime', 'wm.accessibility_basic'] },
  'wm-calendar': { widget: 'wm.calendar', parent: ['wm.base', 'wm.base.datetime', 'wm.accessibility_basic'] },
  'wm-time': { widget: 'wm.time', parent: ['wm.base', 'wm.base.editors.abstracteditors', 'wm.base.datetime', 'wm.accessibility_basic'] },
  'wm-datetime': { widget: 'wm.datetime', parent: ['wm.base', 'wm.base.editors.abstracteditors', 'wm.base.datetime', 'wm.accessibility_basic'] },
  'wm-fileupload': { widget: 'wm.fileupload', parent: ['wm.base', 'wm.base.advancedformwidgets', 'wm.accessibility_basic'] },
  'wm-colorpicker': { widget: 'wm.colorpicker', parent: ['wm.base', 'wm.base.events', 'wm.base.events.focus', 'wm.base.events.change'] },
  'wm-slider': { widget: 'wm.slider', parent: ['wm.base', 'wm.base.events.change'] },
  'wm-rating': { widget: 'wm.rating', parent: ['wm.base', 'wm.base.editors', 'wm.accessibility_basic'] },
  'wm-radioset': { widget: 'wm.radioset', parent: ['wm.base', 'wm.base.editors.dataseteditors', 'wm.accessibility_basic'] },

  ///  properties of Data Widgets ///
  'wm-table': { widget: 'wm.table', parent: ['wm.base', 'wm.base.navigation', 'wm.layouts.panel.defaults'] },
  'wm-table-column': { widget: 'wm.table.column' },
  'wm-livetable': { widget: 'wm.livetable', parent: ['wm.base', 'wm.base.navigation', 'wm.layouts.panel.defaults'] },
  'wm-list': { widget: 'wm.list', parent: ['wm.base', 'wm.containers', 'wm.base.events', 'wm.base.navigation', 'wm.layouts.panel.defaults', 'wm.containers.layout'] },
  'wm-listtemplate': { widget: 'wm.layouts.listtemplate', parent: '' },
  'wm-form': { widget: 'wm.layouts.form', parent: ['wm.base', 'wm.base.events.touch', 'wm.layouts.panel.defaults'] },
  'wm-liveform': { widget: 'wm.layouts.liveform', parent: ['wm.base', 'wm.base.events.successerror', 'wm.layouts.panel.defaults'] },
  'wm-livefilter': { widget: 'wm.livefilter', parent: ['wm.base', 'wm.layouts.panel.defaults'] },
  'wm-card': { widget: 'wm.layouts.card', parent: ['wm.base', 'wm.base.events', 'wm.menu.dataProps'] },
  'wm-card-content': { widget: 'wm.layouts.cardcontent', parent: ['wm.base', 'wm.layouts'] },
  'wm-card-action': { widget: 'wm.layouts.cardactions', parent: ['wm.base'] },
  'wm-card-footer': { widget: 'wm.layouts.cardfooter', parent: ['wm.base'] },

  ///  properties of  Container Widgets  ///
  'wm-layoutgrid': { widget: 'wm.layouts.layoutgrid', parent: '' },
  'wm-gridcolumn': { widget: 'wm.layouts.gridcolumn', parent: '' },
  'wm-layout-grid-row': { widget: 'wm.layouts.gridrow', parent: '' },
  'wm-linearlayout': { widget: 'wm.layouts.linearlayout', parent: ['wm.base', 'wm.containers', 'wm.containers.borderstyle', 'wm.dynamicstyles', 'wm.containers.layout'] },
  'wm-linearlayoutitem': { widget: 'wm.layouts.linearlayoutitem', parent: ['wm.base', 'wm.containers', 'wm.containers.borderstyle', 'wm.dynamicstyles', 'wm.base.events.touch', 'wm.containers.layout'] },
  'wm-accordion': { widget: 'wm.accordion', parent: ['wm.base', 'wm.layouts.panel.defaults'] },
  'wm-accordionpane': { widget: 'wm.accordionpane', parent: ['wm.base', 'wm.scrollablecontainer'] },
  'wm-tabs': { widget: 'wm.tabs', parent: ['wm.base'] },
  'wm-tabpane': { widget: 'wm.tabpane', parent: ['wm.base', 'wm.layouts', 'wm.scrollablecontainer'] },
  'wm-wizard': { widget: 'wm.wizard', parent: ['wm.base', 'wm.layouts', 'wm.containers', 'wm.containers.layout'] },
  'wm-wizardstep': { widget: 'wm.wizardstep', parent: ['wm.base'] },
  'wm-wizardaction': { widget: 'wm.wizardaction', parent: ['wm.base'] },
  'wm-panel': { widget: 'wm.layouts.panel', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.events.touch', 'wm.menu.dataProps', 'wm.layouts.panel.defaults', 'wm.scrollablecontainer'] },
  'wm-container': { widget: 'wm.layouts.container', parent: ['wm.containers', 'wm.dynamicstyles', 'wm.base.events.touch', 'wm.containers.autolayout'] },
  'wm-tile': { widget: 'wm.layouts.tile', parent: ['wm.containers', 'wm.dynamicstyles', 'wm.base.events.touch', 'wm.containers.layout'] },

  ///  properties of  Basic Widgets  ///

  'wm-label': { widget: 'wm.label', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.advancedformwidgets', 'wm.base.events', 'wm.accessibility_basic'] },
  'wm-anchor': { widget: 'wm.anchor', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.advancedformwidgets', 'wm.base.events', 'wm.base.events.focus', 'wm.accessibility_basic'] },
  'wm-icon': { widget: 'wm.icon', parent: ['wm.base', 'wm.dynamicstyles', 'wm.accessibility_basic'] },
  'wm-picture': { widget: 'wm.picture', parent: ['wm.base', 'wm.dynamicstyles', 'wm.base.events', 'wm.accessibility_basic'] },
  'wm-tree': { widget: 'wm.tree', parent: ['wm.base', 'wm.containers', 'wm.containers.borderstyle', 'wm.containers.layout'] },
  'wm-video': { widget: 'wm.video', parent: ['wm.base'] },
  'wm-audio': { widget: 'wm.audio', parent: ['wm.base'] },
  'wm-html': { widget: 'wm.html', parent: ['wm.base', 'wm.base.editors', 'wm.containers', 'wm.containers.borderstyle', 'wm.base.events', 'wm.containers.layout'] },
  'wm-iframe': { widget: 'wm.iframe', parent: ['wm.base'] },
  'wm-message': { widget: 'wm.message', parent: ['wm.base', 'wm.accessibility_basic'] },
  'wm-search': { widget: 'wm.search', parent: ['wm.base', 'wm.base.editors.abstracteditors', 'wm.accessibility_basic'] },
  'wm-richtexteditor': { widget: 'wm.richtexteditor', parent: ['wm.base'] },
  'wm-progress-bar': { widget: 'wm.progress.bar', parent: ['wm.base', 'wm.base.events'] },
  'wm-progress-circle': { widget: 'wm.progress.circle', parent: ['wm.base', 'wm.base.events'] },
  'wm-spinner': { widget: 'wm.spinner', parent: ['wm.base'] },


  ///  properties of  chart  ///
  'wm-chart': { widget: 'wm.chart', parent: ['wm.base', 'wm.accessibility_basic'] },
  'wm-composite': { widget: 'wm.composite', parent: ['wm.base', 'wm.containers', 'wm.containers.layout'] },

  ///  properties of  Navigation Widgets  ///
  'wm-nav': { widget: 'wm.layouts.nav', parent: ['wm.containers', 'wm.menu.dataProps', 'wm.containers.layout'] },
  'wm-nav-item': { widget: 'wm.layouts.navitem', parent: ['wm.base'] },
  'wm-navbar': { widget: 'wm.layouts.navbar', parent: ['wm.base'] },
  'wm-breadcrumb': { widget: 'wm.layouts.breadcrumb', parent: ['wm.containers', 'wm.menu.dataProps', 'wm.containers.layout'] },
  'wm-menu': { widget: 'wm.menu', parent: ['wm.base', 'wm.base.advancedformwidgets', 'wm.menu.dataProps'] },
  'wm-popover': { widget: 'wm.popover', parent: ['wm.base', 'wm.base.advancedformwidgets', 'wm.anchor'] },

  ///  properties of  Advanced Widgets  ///

  'wm-login': { widget: 'wm.login', parent: ['wm.base', 'wm.layouts.login', 'wm.base.events.successerror'] },
  'wm-marquee': { widget: 'wm.marquee', parent: ['wm.base'] },
  'wm-custom': { widget: 'wm.custom', parent: ['wm.base'] },
  'wm-carousel': { widget: 'wm.carousel', parent: ['wm.base'] },
  'wm-carousel-content': { widget: 'wm.carousel.content', parent: ['wm.base', 'wm.containers', 'wm.containers.layout'] },
  'wm-carousel-template': { widget: 'wm.carousel.template', parent: ['wm.base', 'wm.containers', 'wm.containers.layout'] },

  ///  properties of  Modal Windows/Dialogs  ///
  'wm-dialog': { widget: 'wm.designdialog', parent: ['wm.basicdialog', 'wm.base'] },
  'wm-dialogcontainer': { widget: 'wm.designdialog', parent: ['wm.basicdialog', "wm.base"] },
  'wm-dialogheader': { widget: "wm.dialog.dialogheader", parent: ["wm.base"] },
  'wm-dialogactions': { widget: 'wm.dialog.dialogactions', parent: ['wm.base'] },
  'wm-alertdialog': { widget: 'wm.alertdialog', parent: ["wm.basicdialog", "wm.base", "wm.dialog.onOk"] },
  'wm-confirmdialog': { widget: "wm.confirmdialog", parent: ["wm.basicdialog", "wm.base", "wm.dialog.onOk"] },
  'wm-iframedialog': { widget: "wm.iframedialog", parent: ["wm.basicdialog", "wm.base", "wm.dialog.onOk"] },
  'wm-pagedialog': { widget: "wm.pagedialog", parent: ["wm.basicdialog", "wm.base", "wm.dialog.onOk", "wm.pagecontainer"] },
  'wm-pagedialogcontainer': { widget: "wm.pagedialog", parent: ["wm.basicdialog", "wm.base", "wm.dialog.onOk"] },
  'wm-logindialog': { widget: 'wm.logindialog', parent: ['wm.basicdialog', 'wm.base', 'wm.base.events.successerror'] },
  'wm-logindialogcontainer': { widget: 'wm.logindialog', parent: ['wm.base'] },

  ///  properties of  form-field widgets  ///
  'wm-form-field-upload': { widget: '', parent: ['wm.base', 'wm.base.editors', 'wm.base.editors.abstracteditors'] },
  'wm-form-field-toggle': { widget: 'wm.checkbox', parent: ['wm.base', 'wm.base.editors.abstracteditors', 'wm.toggle'] },
  'wm-form-field-iconbutton-toggle': { widget: 'wm.checkbox', parent: ['wm.base', 'wm.base.editors.abstracteditors', 'wm.icon_button_toggle'] },
  'wm-form-field-checkbox': { widget: 'wm.checkbox', parent: ['wm.base', 'wm.base.editors.abstracteditors'] },
  'wm-form-field-chips': { widget: 'wm.chips', parent: ['wm.base', 'wm.base.editors.dataseteditors'] },

  'wm-mobile-navbar': { widget: 'wm.layouts.mobile.navbar', parent: ['wm.base'] },
  'wm-mobile-tabbar': { widget: 'wm.tabbar', parent: ['wm.base', 'wm.tabbar.dataProps'] },
  'wm-camera': { widget: 'wm.camera', parent: ['wm.base', 'wm.base.advancedformwidgets', 'wm.accessibility_basic'] },
  'wm-barcodescanner': { widget: 'wm.barcodescanner', parent: ['wm.base', 'wm.base.advancedformwidgets', 'wm.accessibility_basic'] },
  'wm-bottomsheet': { widget: 'wm.bottomsheet', parent: ['wm.base'] },
  'wm-lottie': { widget: 'wm.lottie', parent: ['wm.base'] },
  'wm-webview': { widget: 'wm.webview', parent: ['wm.base'] },

  ///  properties of  custom widgets  ///
  'wm-custom-widget': { widget: 'wm.custom.widget', parent: ['wm.base'] },
  'wm-custom-widget-container': { widget: 'wm.custom.widget.container', parent: ['wm.base'] },
}
